import React, { useEffect, useState } from "react";
import api from "../lib/api";
import PageHeader from "../components/PageHeader";
import FirinSiparisRaporu from "../components/FirinSiparisRaporu";
import SiparisIsBolumuRaporu from "../components/SiparisIsBolumuRaporu";
import KaliteGecmeyenCell from "../components/KaliteGecmeyenCell";
import { MakineOzetExport } from "../components/MakineOzetExport";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { yazdirBaslikli, damga } from "../lib/stamp";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { useNavigate } from "react-router-dom";
import {
  RadialBarChart, RadialBar, PolarAngleAxis, ResponsiveContainer,
  ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid,
} from "recharts";
import { ClipboardList, Printer, Trophy, Factory, FileDown, Loader2, CalendarClock, X, ChevronRight, AlertTriangle } from "lucide-react";

const FAB_IMGS = [
  "https://images.unsplash.com/photo-1720414575054-495b08f059e7?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  "https://images.unsplash.com/photo-1595446472632-9a3dfdd51bd9?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  "https://images.unsplash.com/photo-1642355779808-4285b3987239?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
];

const fmt = (n) => (n == null ? "0" : Number(n).toLocaleString("tr-TR"));
const COLORS = ["#16A34A", "#EAB308", "#0284C7", "#DC2626"];

const BOLUM_OPTS = ["Dekor", "Dijital", "Sırlama", "Logo"];

const trTarih = (s) => {
  if (!s) return "—";
  const p = String(s).slice(0, 10).split("-");
  return p.length === 3 ? `${p[2]}.${p[1]}.${p[0]}` : s;
};
const gunLabel = (g) => {
  if (g === null || g === undefined) return "—";
  if (g < 0) return `${Math.abs(g)} gün gecikti`;
  if (g === 0) return "Bugün";
  return `${g} gün kaldı`;
};

const TCFG = {
  gecti: { label: "Termini Geçen", txt: "text-red-400" },
  yaklasiyor: { label: "Termini Yaklaşan", txt: "text-emerald-400" },
  uzak: { label: "Termini Uzak", txt: "text-sky-400" },
};

const KALITE_ALANLARI = [
  { key: "kalite1", label: "1. Kalite" },
  { key: "kalite2", label: "2. Kalite" },
  { key: "kalite3", label: "3. Kalite" },
  { key: "fire", label: "Fire" },
  { key: "kenar_catlak", label: "Kenar Çatlak" },
  { key: "ayak_kirik", label: "Ayak Kırık" },
  { key: "demir_leke", label: "Demir Leke" },
  { key: "capak", label: "Çapak" },
  { key: "kirik_sirlama", label: "Kırık Sırlama" },
  { key: "boya_puskurtme", label: "Boyalı/Boya Püskürtme" },
  { key: "rotus_hatasi", label: "Rötuş Hatası" },
  { key: "hamur_havali", label: "Hamur Havalı" },
  { key: "sirsiz", label: "Sırsız" },
  { key: "ayak_catlak", label: "Ayak Çatlak" },
  { key: "tozlu_sirlama", label: "Tozlu Sırlama" },
  { key: "deform", label: "Deform" },
  { key: "kulp_acik", label: "Kulp Açık" },
  { key: "kalip_hatasi", label: "Kalıp Hatası" },
  { key: "cokme", label: "Çökme" },
  { key: "sir_yirtilma", label: "Sır Yırtılma" },
  { key: "pinho", label: "Pinho" },
  { key: "puskurtme", label: "Püskürtme" },
  { key: "sir_atma", label: "Sır Atma" },
  { key: "reduksiyon", label: "Redüksiyon" },
  { key: "sir_deligi", label: "Sır Deliği" },
  { key: "sir_acigi_carpma", label: "Sır Açığı/Çarpma" },
  { key: "sir_birikme", label: "Sır Birikme" },
  { key: "tamir", label: "Tamir" },
  { key: "sir_akma_birikme", label: "Sır Akma/Birikme" },
];

const Th = ({ children, r }) => <th className={`px-3 py-2 text-[11px] font-bold uppercase tracking-wide text-zinc-500 border-b border-zinc-200 bg-zinc-50 sticky top-0 z-10 ${r ? "text-right" : "text-left"}`}>{children}</th>;
const Td = ({ children, r, cls = "" }) => <td className={`px-3 py-2 border-b border-zinc-100 ${r ? "text-right num" : ""} ${cls}`}>{children}</td>;

const DateFilter = ({ start, end, setStart, setEnd, testidPrefix }) => (
  <div className="ml-auto flex items-end gap-2 no-print">
    <div>
      <label className="block text-[10px] uppercase tracking-widest text-zinc-400 mb-0.5">Başlangıç</label>
      <input type="date" value={start} onChange={(e) => setStart(e.target.value)} data-testid={`${testidPrefix}-start`}
        className="bg-white/10 border border-white/15 rounded px-2 py-1 text-xs text-white [color-scheme:dark]" />
    </div>
    <div>
      <label className="block text-[10px] uppercase tracking-widest text-zinc-400 mb-0.5">Bitiş</label>
      <input type="date" value={end} onChange={(e) => setEnd(e.target.value)} data-testid={`${testidPrefix}-end`}
        className="bg-white/10 border border-white/15 rounded px-2 py-1 text-xs text-white [color-scheme:dark]" />
    </div>
    {(start || end) && (
      <button onClick={() => { setStart(""); setEnd(""); }} data-testid={`${testidPrefix}-temizle`}
        className="text-[11px] text-amber-300 hover:text-amber-200 underline pb-1.5">Temizle</button>
    )}
  </div>
);

function BigStat({ label, value, accent, sub, onClick, testid }) {
  const clickable = !!onClick;
  return (
    <div onClick={onClick} data-testid={testid}
      className={`rounded-md bg-white/5 border border-white/10 px-4 py-4 backdrop-blur transition-all ${clickable ? "cursor-pointer hover:-translate-y-0.5 hover:ring-1 hover:ring-amber-500/50" : ""}`}>
      <div className="flex items-center gap-1 text-[11px] font-semibold uppercase tracking-widest text-zinc-400">
        {label}{clickable && <ChevronRight size={12} className="text-amber-400/60" />}
      </div>
      <div className={`font-head font-black text-3xl mt-1 num ${accent}`}>{value}</div>
      {sub && <div className="text-[11px] text-zinc-500 mt-0.5">{sub}</div>}
    </div>
  );
}

export default function Dashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [kaliteGecikme, setKaliteGecikme] = useState(null);
  const [gecikmeTrend, setGecikmeTrend] = useState([]);
  const [s, setS] = useState(null);
  const [dag, setDag] = useState(null);
  const [kal, setKal] = useState(null);
  const [kalDetay, setKalDetay] = useState(null);
  const [sekMak, setSekMak] = useState([]);
  const [termin, setTermin] = useState([]);
  const [kStart, setKStart] = useState("");
  const [kEnd, setKEnd] = useState("");
  const [kKalip, setKKalip] = useState("");
  const [kUrun, setKUrun] = useState("");
  const [pdfBusy, setPdfBusy] = useState(false);
  const [horecaF, setHorecaF] = useState("all");
  const [mStart, setMStart] = useState("");
  const [mEnd, setMEnd] = useState("");
  const [detail, setDetail] = useState(null);
  const [siparisDetay, setSiparisDetay] = useState(null);
  const [planDetay, setPlanDetay] = useState(null);
  const [makineDetay, setMakineDetay] = useState(null);
  const [yapilanDetay, setYapilanDetay] = useState(null);
  const [planStart, setPlanStart] = useState("");
  const [planEnd, setPlanEnd] = useState("");
  const [bolum, setBolum] = useState(null);
  const [vardiyaOzet, setVardiyaOzet] = useState(null);
  const [ozetStart, setOzetStart] = useState("");
  const [ozetEnd, setOzetEnd] = useState("");
  const [hedefOpen, setHedefOpen] = useState(false);
  const [hedefForm, setHedefForm] = useState({});

  const dataUrlFrom = (url) => fetch(url).then((r) => r.blob()).then((b) => new Promise((res) => {
    const fr = new FileReader(); fr.onload = () => res(fr.result); fr.readAsDataURL(b);
  }));

  const exportPanolarPdf = async () => {
    const el = document.querySelector(".print-area");
    if (!el) return;
    setPdfBusy(true);
    try {
      const canvas = await html2canvas(el, {
        scale: 2, useCORS: true, backgroundColor: "#ffffff",
        ignoreElements: (e) => e.classList?.contains?.("no-print"),
      });
      const img = canvas.toDataURL("image/jpeg", 0.92);
      const pdf = new jsPDF("p", "mm", "a4");
      const pageW = pdf.internal.pageSize.getWidth();
      const pageH = pdf.internal.pageSize.getHeight();
      const margin = 8;
      const headerH = 22;
      pdf.setFillColor(24, 24, 27);
      pdf.rect(0, 0, pageW, headerH, "F");
      try {
        const logo = await dataUrlFrom("/by-bone-logo.png");
        const im = new Image(); im.src = logo;
        await new Promise((r) => { im.onload = r; im.onerror = r; });
        const lh = 14; const lw = im.width && im.height ? (im.width / im.height) * lh : 14;
        pdf.addImage(logo, "PNG", margin, (headerH - lh) / 2, lw, lh);
      } catch { /* logo yoksa atla */ }
      pdf.setTextColor(255, 255, 255);
      pdf.setFont("helvetica", "bold"); pdf.setFontSize(14);
      pdf.text("Gösterge Paneli", pageW - margin, 10, { align: "right" });
      pdf.setFont("helvetica", "normal"); pdf.setFontSize(9);
      pdf.setTextColor(245, 158, 11);
      pdf.text("BY BONE PORSELEN", pageW - margin, 15, { align: "right" });
      pdf.setTextColor(200, 200, 200);
      pdf.text(new Date().toLocaleString("tr-TR"), pageW - margin, 19.5, { align: "right" });
      const availW = pageW - margin * 2;
      const availH = pageH - margin - (headerH + 4);
      const ratio = canvas.width / canvas.height;
      let w = availW; let h = w / ratio;
      if (h > availH) { h = availH; w = h * ratio; }
      const x = (pageW - w) / 2;
      const y = headerH + 4;
      pdf.addImage(img, "JPEG", x, y, w, h);
      pdf.save(`Gösterge Paneli - ${damga()}.pdf`);
    } finally { setPdfBusy(false); }
  };

  useEffect(() => {
    api.get("/dashboard/stats").then((r) => setS(r.data)).catch(() => {});
    api.get("/dashboard/siparis-dagilim").then((r) => setDag(r.data)).catch(() => {});
    api.get("/dashboard/termin").then((r) => setTermin(r.data)).catch(() => {});
    api.get("/dashboard/plan-durum").then((r) => setPlanDetay(r.data || [])).catch(() => setPlanDetay([]));
    api.get("/dashboard/kaliteden-gecmeyen", { params: { ozet: true } }).then((r) => setKaliteGecikme(r.data)).catch(() => {});
    api.get("/dashboard/kalite-gecikme-trend").then((r) => setGecikmeTrend(r.data || [])).catch(() => {});
  }, []);

  useEffect(() => {
    const params = {};
    if (kStart) params.start = kStart;
    if (kEnd) params.end = kEnd;
    if (kKalip.trim()) params.kalip_kodu = kKalip.trim();
    if (kUrun.trim()) params.urun_kodu = kUrun.trim();
    api.get("/dashboard/kalite-gunluk", { params }).then((r) => setKal(r.data)).catch(() => {});
    api.get("/dashboard/kalite-detay", { params }).then((r) => setKalDetay(r.data)).catch(() => {});
  }, [kStart, kEnd, kKalip, kUrun]);

  useEffect(() => {
    const params = {};
    if (mStart) params.start = mStart;
    if (mEnd) params.end = mEnd;
    api.get("/dashboard/sekillenen-makina", { params }).then((r) => setSekMak(r.data)).catch(() => {});
  }, [mStart, mEnd]);

  useEffect(() => {
    const params = {};
    if (ozetStart) params.start = ozetStart;
    if (ozetEnd) params.end = ozetEnd;
    api.get("/dashboard/bolum-kirilim", { params }).then((r) => setBolum(r.data)).catch(() => setBolum(null));
    api.get("/dashboard/vardiya-ozeti", { params }).then((r) => setVardiyaOzet(r.data)).catch(() => setVardiyaOzet(null));
  }, [ozetStart, ozetEnd]);

  const ensureSiparis = () => {
    if (siparisDetay) return;
    api.get("/orders/with-progress").then((r) =>
      setSiparisDetay((r.data || []).filter((o) => (Number(o.kalan) || 0) > 0))
    ).catch(() => setSiparisDetay([]));
  };
  const ensurePlan = () => {
    if (planDetay) return;
    api.get("/dashboard/plan-durum").then((r) => setPlanDetay(r.data || [])).catch(() => setPlanDetay([]));
  };

  const openKalite = (field, label) => setDetail({ kind: "kalite", field, label });
  const openSiparis = (filter, label) => { ensureSiparis(); setDetail({ kind: "siparis", filter, label }); };
  const openPlan = (durum, label, tarih = null) => { ensurePlan(); setDetail({ kind: "plan", durum, tarih, label }); };
  const openTermin = (durum, label) => setDetail({ kind: "termin", durum, label });
  const openMakine = (row) => {
    setDetail({ kind: "makine", makina: row?.makina || null, label: row?.makina ? `${row.makina} — Ürün Detayı` : "Şekillenen Ürün — Makine Bazında Detay" });
    setMakineDetay(null);
    const params = {};
    if (mStart) params.start = mStart;
    if (mEnd) params.end = mEnd;
    api.get("/dashboard/sekillenen-makina-detay", { params }).then((r) => setMakineDetay(r.data || [])).catch(() => setMakineDetay([]));
  };

  const openYapilan = (kind, val, label) => {
    setDetail({ kind: "yapilan", label });
    setYapilanDetay(null);
    const params = {};
    if (kind === "bolum") params.bolum = val;
    if (kind === "vardiya") params.vardiya = val;
    if (ozetStart) params.start = ozetStart;
    if (ozetEnd) params.end = ozetEnd;
    api.get("/dashboard/yapilan-detay", { params }).then((r) => setYapilanDetay(r.data)).catch(() => setYapilanDetay({ rows: [] }));
  };

  const reloadBolum = () => {
    const params = {};
    if (ozetStart) params.start = ozetStart;
    if (ozetEnd) params.end = ozetEnd;
    api.get("/dashboard/bolum-kirilim", { params }).then((r) => setBolum(r.data)).catch(() => {});
  };
  const openHedef = () => {
    api.get("/bolum-hedef").then((r) => {
      const m = {}; (r.data || []).forEach((h) => { m[h.bolum] = h; });
      const form = {};
      BOLUM_OPTS.forEach((b) => { form[b] = { gunluk_hedef: m[b]?.gunluk_hedef ?? "", aylik_hedef: m[b]?.aylik_hedef ?? "" }; });
      setHedefForm(form); setHedefOpen(true);
    }).catch(() => {
      const form = {}; BOLUM_OPTS.forEach((b) => { form[b] = { gunluk_hedef: "", aylik_hedef: "" }; });
      setHedefForm(form); setHedefOpen(true);
    });
  };
  const saveHedef = async () => {    try {
      await Promise.all(BOLUM_OPTS.map((b) => api.post("/bolum-hedef", {
        bolum: b, gunluk_hedef: Number(hedefForm[b]?.gunluk_hedef) || 0, aylik_hedef: Number(hedefForm[b]?.aylik_hedef) || 0,
      })));
      toast.success("Bölüm hedefleri kaydedildi");
      setHedefOpen(false);
      reloadBolum();
    } catch { toast.error("Hedefler kaydedilemedi"); }
  };
  const indirAylikRapor = async () => {
    const now = new Date();
    const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
    const s = iso(new Date(now.getFullYear(), now.getMonth(), 1));
    const e = iso(new Date(now.getFullYear(), now.getMonth() + 1, 0));
    try {
      const res = await api.get("/reports/aylik-excel", { params: { start: s, end: e }, responseType: "blob" });
      const url = URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a"); a.href = url; a.download = `Aylık Rapor ${s} - ${e}.xlsx`; a.click();
      URL.revokeObjectURL(url);
      toast.success("Bu ayın raporu indiriliyor (8 sayfalı Excel)");
    } catch { toast.error("Rapor indirilemedi"); }
  };

  const terminCounts = {
    gecti: termin.filter((t) => t.termin_durum === "gecti").length,
    yaklasiyor: termin.filter((t) => t.termin_durum === "yaklasiyor").length,
    uzak: termin.filter((t) => t.termin_durum === "uzak").length,
  };
  const terminEnYakin = [...termin]
    .filter((t) => t.kalan_gun !== null && t.kalan_gun !== undefined)
    .sort((a, b) => a.kalan_gun - b.kalan_gun)
    .slice(0, 6);

  if (!s) return (
    <>
      <PageHeader logo="/by-bone-logo.png" title="Gösterge Paneli" subtitle={`Hoş geldiniz, ${user?.name || ""}`} />
      <div className="p-6 text-zinc-400">Yükleniyor...</div>
    </>
  );

  const kt = kal?.totals || {};
  const kTop = kal?.toplam || 0;
  const kPct = (v) => (kTop ? `%${((Number(v) || 0) / kTop * 100).toFixed(1)} · toplamın payı` : "");
  const kaliteRaporRows = () => KALITE_ALANLARI.map((f) => ({ key: f.key, ad: f.label, adet: kt[f.key] || 0 })).filter((e) => e.adet > 0 && (["kalite1", "kalite2", "kalite3", "fire"].includes(e.key) || !kTop || e.adet < kTop));
  const kPctNum = (v) => (kTop ? ((Number(v) || 0) / kTop * 100).toFixed(1) : "0.0");
  const HATA_KEYS = KALITE_ALANLARI.slice(4);
  const hataRows = () => HATA_KEYS.map((f) => ({ key: f.key, ad: f.label, adet: Number(kt[f.key]) || 0 })).filter((e) => e.adet > 0 && (!kTop || e.adet < kTop)).sort((a, b) => b.adet - a.adet);
  const hataToplam = hataRows().reduce((a, b) => a + b.adet, 0);
  const hPctNum = (v) => (hataToplam ? ((Number(v) || 0) / hataToplam * 100).toFixed(1) : "0.0");
  const kFiltreMetni = [kKalip.trim() && `Kalıp: ${kKalip.trim()}`, kUrun.trim() && `Ürün: ${kUrun.trim()}`, (kStart || kEnd) && `Tarih: ${kStart || "…"} — ${kEnd || "…"}`].filter(Boolean).join(" · ");
  const kFiltreDosya = [kKalip.trim(), kUrun.trim()].filter(Boolean).join("-");
  const kEsc = (v) => String(v ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  const exportKaliteExcel = () => {
    const rr = kaliteRaporRows();
    const cap = kFiltreMetni ? `<tr><td colspan="3" style="background:#FEF3C7;font-weight:bold;">Filtre: ${kEsc(kFiltreMetni)}</td></tr>` : "";
    const head = ["Kategori", "Adet", "Toplam İçindeki Pay"].map((c) => `<th style="background:#18181B;color:#fff;font-weight:bold;">${kEsc(c)}</th>`).join("");
    const body = rr.map((e) => `<tr><td>${kEsc(e.ad)}</td><td>${e.adet}</td><td>%${kPctNum(e.adet)}</td></tr>`).join("");
    const foot = `<tr style="background:#E9E9E9;font-weight:bold;"><td>TOPLAM</td><td>${kTop}</td><td>%100</td></tr>`;
    const hr = hataRows();
    const hBlock = hr.length ? `<br/><table border="1"><tr><th colspan="3" style="background:#18181B;color:#fff;font-weight:bold;">Hata Nedeni Dökümü (2. Kalite &amp; Fire Nedenleri)</th></tr><tr><th style="background:#7f1d1d;color:#fff;">Hata Nedeni</th><th style="background:#7f1d1d;color:#fff;">Adet</th><th style="background:#7f1d1d;color:#fff;">Pay</th></tr>${hr.map((e) => `<tr><td>${kEsc(e.ad)}</td><td>${e.adet}</td><td>%${hPctNum(e.adet)}</td></tr>`).join("")}<tr style="background:#E9E9E9;font-weight:bold;"><td>TOPLAM</td><td>${Math.round(hataToplam)}</td><td>%100</td></tr></table>` : "";
    const html = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel"><head><meta charset="utf-8"></head><body><table border="1">${cap}<tr>${head}</tr>${body}${foot}</table>${hBlock}</body></html>`;
    const blob = new Blob(["\ufeff", html], { type: "application/vnd.ms-excel" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = `Kalite Takibi Özeti${kFiltreDosya ? " - " + kFiltreDosya : ""} - ${damga()}.xls`; a.click();
    URL.revokeObjectURL(url);
  };
  const exportKalitePdf = () => {
    const rr = kaliteRaporRows();
    const hr = hataRows();
    const hPdf = hr.length ? `<h2 style="font-size:13px;text-transform:uppercase;letter-spacing:1px;color:#7f1d1d;margin:18px 0 6px">Hata Nedeni Dökümü — 2. Kalite &amp; Fire Nedenleri</h2>
      <table><thead><tr><th>Hata Nedeni</th><th class="r">Adet</th><th class="r">Pay</th></tr></thead>
      <tbody>${hr.map((e) => `<tr><td>${kEsc(e.ad)}</td><td class="r" style="font-weight:bold;color:#b91c1c">${e.adet.toLocaleString("tr-TR")}</td><td class="r">%${hPctNum(e.adet)}</td></tr>`).join("")}</tbody>
      <tfoot><tr><td>TOPLAM</td><td class="r">${Math.round(hataToplam).toLocaleString("tr-TR")}</td><td class="r">%100</td></tr></tfoot></table>` : "";
    const w = window.open("", "_blank"); if (!w) return;
    const body = rr.map((e) => `<tr><td>${kEsc(e.ad)}</td><td class="r">${e.adet.toLocaleString("tr-TR")}</td>
      <td class="r"><div class="barw"><div class="bar" style="width:${kPctNum(e.adet)}%"></div></div></td>
      <td class="r" style="font-weight:bold">%${kPctNum(e.adet)}</td></tr>`).join("");
    w.document.write(`<!DOCTYPE html><html lang="tr"><head><meta charset="utf-8"><title>Kalite Takibi Özeti - ${damga()}</title>
      <style>@page{size:A4 portrait;margin:12mm}*{-webkit-print-color-adjust:exact;print-color-adjust:exact}body{font-family:'Segoe UI',Arial,sans-serif;color:#18181B;margin:0}
      .hdr{display:flex;align-items:center;justify-content:space-between;border-bottom:3px solid #d97706;padding-bottom:12px;margin-bottom:6px}
      .hdr .l{display:flex;align-items:center;gap:14px}.hdr img{height:52px}.hdr h1{font-size:20px;margin:0}.hdr .sub{font-size:12px;color:#6b7280;margin-top:2px}
      .hdr .meta{text-align:right;font-size:11px;color:#6b7280;line-height:1.6}
      .cards{display:flex;gap:12px;margin:14px 0}.card{flex:1;border:1px solid #e5e7eb;border-radius:8px;padding:10px 14px;background:#fafafa}
      .card .k{font-size:10px;text-transform:uppercase;letter-spacing:1.5px;color:#9ca3af}.card .v{font-size:22px;font-weight:800;margin-top:4px}
      table{width:100%;border-collapse:collapse;font-size:12px;margin-top:6px}th{background:#18181B;color:#fff;padding:8px;text-align:left;font-size:10px;text-transform:uppercase}
      td{border-bottom:1px solid #eee;padding:7px 8px}.r{text-align:right}
      .barw{display:inline-block;width:120px;height:8px;background:#eee;border-radius:4px;overflow:hidden;vertical-align:middle}.bar{height:8px;background:#d97706}
      tfoot td{border-top:2px solid #18181B;font-weight:800;background:#f4f4f5}.foot{margin-top:16px;font-size:10px;color:#9ca3af;text-align:center;border-top:1px solid #eee;padding-top:8px}</style></head>
      <body><div class="hdr"><div class="l"><img src="${window.location.origin}/by-bone-logo.png"/><div><h1>Kalite Takibi Özeti</h1><div class="sub">BY BONE PORSELEN — Kalite Dağılım Raporu</div></div></div>
      <div class="meta">Tarih: ${new Date().toLocaleString("tr-TR")}<br/>Kategori: ${rr.length}${kFiltreMetni ? `<br/>Filtre: ${kEsc(kFiltreMetni)}` : ""}</div></div>
      <div class="cards">
        <div class="card"><div class="k">Toplam Adet</div><div class="v">${kTop.toLocaleString("tr-TR")}</div></div>
        <div class="card"><div class="k">1. Kalite Verimi</div><div class="v" style="color:#047857">%${kal?.fire_orani ?? 0}</div></div>
        <div class="card"><div class="k">Toplam Geçen KG</div><div class="v" style="color:#b45309">${fmt(kal?.toplam_kg)}</div></div>
        <div class="card"><div class="k">FASON / HORECA</div><div class="v" style="font-size:16px">${fmt(kal?.fason)} / ${fmt(kal?.horeca)}</div></div>
      </div>
      <table><thead><tr><th>Kategori</th><th class="r">Adet</th><th class="r">Dağılım</th><th class="r">Pay</th></tr></thead>
      <tbody>${body}</tbody>
      <tfoot><tr><td>TOPLAM</td><td class="r">${kTop.toLocaleString("tr-TR")}</td><td></td><td class="r">%100</td></tr></tfoot></table>
      ${hPdf}
      <div class="foot">Bu rapor BY BONE Üretim Takip Sistemi tarafından otomatik oluşturulmuştur.</div></body></html>`);
    w.document.close(); w.focus(); setTimeout(() => w.print(), 400);
  };

  const exportOzetExcel = () => {
    const bRows = (bolum?.rows || []);
    const vRows = (vardiyaOzet?.rows || []);
    const bHead = ["Bölüm", "Toplam Adet", "1.Kalite", "Fire", "KG"].map((c) => `<th style="background:#18181B;color:#fff;font-weight:bold;">${kEsc(c)}</th>`).join("");
    const bBody = bRows.map((b) => `<tr><td>${kEsc(b.bolum)}</td><td>${b.toplam}</td><td>${b.kalite1}</td><td>${b.fire}</td><td>${b.kg}</td></tr>`).join("");
    const bFoot = `<tr style="background:#E9E9E9;font-weight:bold;"><td>TOPLAM</td><td>${bolum?.genel_toplam ?? 0}</td><td></td><td></td><td>${bolum?.genel_kg ?? 0}</td></tr>`;
    const vHead = ["Vardiya", "Üretim", "Fire", "KG"].map((c) => `<th style="background:#18181B;color:#fff;font-weight:bold;">${kEsc(c)}</th>`).join("");
    const vBody = vRows.map((v) => `<tr><td>${kEsc(v.vardiya)}</td><td>${v.uretim}</td><td>${v.fire}</td><td>${v.kg}</td></tr>`).join("");
    const vFoot = `<tr style="background:#E9E9E9;font-weight:bold;"><td>TOPLAM</td><td>${vardiyaOzet?.toplam_uretim ?? 0}</td><td>${vardiyaOzet?.toplam_fire ?? 0}</td><td>${vardiyaOzet?.toplam_kg ?? 0}</td></tr>`;
    const html = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel"><head><meta charset="utf-8"></head><body>
      <h3>Bölüm Bazında Üretim</h3><table border="1"><tr>${bHead}</tr>${bBody}${bFoot}</table><br/>
      <h3>Vardiya Özeti</h3><table border="1"><tr>${vHead}</tr>${vBody}${vFoot}</table></body></html>`;
    const blob = new Blob(["\ufeff", html], { type: "application/vnd.ms-excel" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = `Bölüm & Vardiya Özeti - ${damga()}.xls`; a.click();
    URL.revokeObjectURL(url);
  };
  const exportOzetPdf = () => {
    const bRows = (bolum?.rows || []);
    const vRows = (vardiyaOzet?.rows || []);
    const w = window.open("", "_blank"); if (!w) return;
    const bBody = bRows.map((b) => `<tr><td>${kEsc(b.bolum)}</td><td class="r">${fmt(b.toplam)}</td><td class="r">${fmt(b.kalite1)}</td><td class="r">${fmt(b.fire)}</td><td class="r">${fmt(b.kg)}</td></tr>`).join("");
    const vBody = vRows.map((v) => `<tr><td>${kEsc(v.vardiya)}</td><td class="r">${fmt(v.uretim)}</td><td class="r">${fmt(v.fire)}</td><td class="r">${fmt(v.kg)}</td></tr>`).join("");
    w.document.write(`<!DOCTYPE html><html lang="tr"><head><meta charset="utf-8"><title>Bölüm & Vardiya Özeti - ${damga()}</title>
      <style>@page{size:A4 portrait;margin:12mm}*{-webkit-print-color-adjust:exact;print-color-adjust:exact}body{font-family:'Segoe UI',Arial,sans-serif;color:#18181B;margin:0}
      .hdr{display:flex;align-items:center;justify-content:space-between;border-bottom:3px solid #d97706;padding-bottom:12px;margin-bottom:14px}
      .hdr .l{display:flex;align-items:center;gap:14px}.hdr img{height:52px}.hdr h1{font-size:20px;margin:0}.hdr .sub{font-size:12px;color:#6b7280;margin-top:2px}
      .hdr .meta{text-align:right;font-size:11px;color:#6b7280;line-height:1.6}
      h2{font-size:13px;text-transform:uppercase;letter-spacing:1px;color:#374151;margin:18px 0 6px}
      table{width:100%;border-collapse:collapse;font-size:12px}th{background:#18181B;color:#fff;padding:8px;text-align:left;font-size:10px;text-transform:uppercase}
      th.r,td.r{text-align:right}td{border-bottom:1px solid #eee;padding:7px 8px}
      tfoot td{border-top:2px solid #18181B;font-weight:800;background:#f4f4f5}
      .foot{margin-top:16px;font-size:10px;color:#9ca3af;text-align:center;border-top:1px solid #eee;padding-top:8px}</style></head>
      <body><div class="hdr"><div class="l"><img src="${window.location.origin}/by-bone-logo.png"/><div><h1>Bölüm & Vardiya Özeti</h1><div class="sub">BY BONE PORSELEN — Yapılan Ürün Raporu</div></div></div>
      <div class="meta">Tarih: ${new Date().toLocaleString("tr-TR")}${(ozetStart || ozetEnd) ? `<br/>Aralık: ${ozetStart || "…"} — ${ozetEnd || "…"}` : ""}</div></div>
      <h2>Bölüm Bazında Üretim</h2>
      <table><thead><tr><th>Bölüm</th><th class="r">Toplam Adet</th><th class="r">1.Kalite</th><th class="r">Fire</th><th class="r">KG</th></tr></thead>
      <tbody>${bBody}</tbody>
      <tfoot><tr><td>TOPLAM</td><td class="r">${fmt(bolum?.genel_toplam)}</td><td class="r"></td><td class="r"></td><td class="r">${fmt(bolum?.genel_kg)}</td></tr></tfoot></table>
      <h2>Vardiya Özeti</h2>
      <table><thead><tr><th>Vardiya</th><th class="r">Üretim</th><th class="r">Fire</th><th class="r">KG</th></tr></thead>
      <tbody>${vBody}</tbody>
      <tfoot><tr><td>TOPLAM</td><td class="r">${fmt(vardiyaOzet?.toplam_uretim)}</td><td class="r">${fmt(vardiyaOzet?.toplam_fire)}</td><td class="r">${fmt(vardiyaOzet?.toplam_kg)}</td></tr></tfoot></table>
      <div class="foot">Bu rapor BY BONE Üretim Takip Sistemi tarafından otomatik oluşturulmuştur.</div></body></html>`);
    w.document.close(); w.focus(); setTimeout(() => w.print(), 400);
  };
  const filterSiparis = (list, f) => (list || []).filter((o) => {
    const sn = (o.satis_noktasi || "").toLowerCase();
    const m = (o.satis_musterisi || "").toLowerCase();
    if (f === "horeca") return sn.includes("horeca");
    if (f === "ihracat") return sn.includes("horeca") && m.includes("hrac");
    if (f === "ic") return sn.includes("horeca") && m.trim() && !m.includes("hrac");
    if (f === "fason") return sn.includes("fason");
    if (f === "diger") return !sn.includes("horeca") && !sn.includes("fason");
    return true;
  });

  const planRows = (planDetay || []).filter((p) => {
    const t = (p.tarih || "").slice(0, 10);
    if (planStart && t && t < planStart) return false;
    if (planEnd && t && t > planEnd) return false;
    return true;
  });
  const _capYap = (p) => Math.min(Number(p.yapilan) || 0, Number(p.planlanan) || 0);
  const planSum = {
    toplam: planRows.length,
    tamamlanan: planRows.filter((p) => p.durum === "Yapıldı").length,
    kismi: planRows.filter((p) => p.durum === "Kısmi").length,
    yapilmayan: planRows.filter((p) => p.durum === "Yapılmadı").length,
    planlanan: planRows.reduce((a, b) => a + (Number(b.planlanan) || 0), 0),
    yapilan: planRows.reduce((a, b) => a + _capYap(b), 0),
  };
  planSum.oran = planSum.planlanan ? Math.round(planSum.yapilan / planSum.planlanan * 100) : 0;
  const _byDay = {};
  planRows.forEach((p) => {
    const t = (p.tarih || "").slice(0, 10) || "—";
    const d = _byDay[t] || (_byDay[t] = { planlanan: 0, yapilan: 0, toplam: 0, tamamlanan: 0, kismi: 0, yapilmayan: 0 });
    d.planlanan += Number(p.planlanan) || 0;
    d.yapilan += _capYap(p);
    d.toplam += 1;
    if (p.durum === "Yapıldı") d.tamamlanan += 1;
    else if (p.durum === "Kısmi") d.kismi += 1;
    else d.yapilmayan += 1;
  });
  const planDays = Object.entries(_byDay)
    .map(([t, d]) => ({ tarih: t, ...d, oran: d.planlanan ? Math.round(d.yapilan / d.planlanan * 100) : 0 }))
    .sort((a, b) => String(b.tarih).localeCompare(String(a.tarih)));

  return (
    <>
      <PageHeader logo="/by-bone-logo.png" title="Gösterge Paneli" subtitle={`Hoş geldiniz, ${user?.name || ""} — Üretim, kalite ve sipariş özeti`}
        actions={
          <div className="flex items-center gap-2">
            <button onClick={exportPanolarPdf} disabled={pdfBusy} data-testid="pano-pdf-btn"
              className="flex items-center gap-2 bg-amber-600 hover:bg-amber-700 disabled:opacity-60 text-white text-sm font-semibold px-3 py-2 rounded-sm">
              {pdfBusy ? <Loader2 size={15} className="animate-spin" /> : <FileDown size={15} />} Panoları PDF'e Aktar
            </button>
            <button onClick={() => yazdirBaslikli("Gösterge Paneli")} data-testid="print-btn"
              className="flex items-center gap-2 border border-zinc-300 hover:bg-zinc-50 text-zinc-700 text-sm font-semibold px-3 py-2 rounded-sm">
              <Printer size={15} /> Yazdır
            </button>
          </div>
        }
      />
      <div className="p-6 space-y-6 print-area">
        {kaliteGecikme && kaliteGecikme.gecikmis > 0 && (
          <div onClick={() => navigate("/uretim?tab=kaliteden_gecmeyen")} data-testid="kalite-gecikme-card"
            className="cursor-pointer flex items-center gap-4 rounded-lg border border-red-200 bg-red-50 px-5 py-4 hover:bg-red-100/70 transition-colors">
            <div className="grid place-items-center h-11 w-11 rounded-full bg-red-100 text-red-600 shrink-0"><AlertTriangle size={22} /></div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-bold text-red-700">Kaliteden Geçmeyen / Gecikmiş Partiler</div>
              <div className="text-xs text-red-500 mt-0.5">{fmt(kaliteGecikme.gecikmis)} parti kalite süresini aştı · {fmt(kaliteGecikme.gecikmis_kalan)} adet kaliteden geçmedi</div>
            </div>
            <div className="font-head font-black text-3xl text-red-600 num">{fmt(kaliteGecikme.gecikmis)}</div>
            <ChevronRight className="text-red-400 shrink-0" size={20} />
          </div>
        )}
        {/* KALİTE TAKİBİ ÖZETİ */}
        <div className="group relative overflow-hidden rounded-lg bg-gradient-to-br from-zinc-900 via-zinc-900 to-zinc-800 p-6 shadow-xl">
          <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-amber-500/10 blur-3xl" />
          <div className="pointer-events-none absolute -left-12 -bottom-12 h-44 w-44 rounded-full bg-amber-400/10 blur-2xl" />
          <div className="relative">
            <div className="flex items-center gap-2 mb-6">
              <Trophy className="text-amber-400" size={18} />
              <h3 className="font-head font-black uppercase tracking-[0.2em] text-white text-sm">Kalite Takibi Özeti</h3>
              <DateFilter start={kStart} end={kEnd} setStart={setKStart} setEnd={setKEnd} testidPrefix="kalite" />
              <div className="flex items-center gap-2 flex-wrap">
                <div className="relative">
                  <input value={kKalip} onChange={(e) => setKKalip(e.target.value)} data-testid="kalite-filter-kalip"
                    placeholder="Kalıp kodu ile filtrele"
                    className="w-44 bg-white/10 border border-white/15 text-white placeholder:text-zinc-500 text-xs rounded-sm pl-2.5 pr-6 py-1.5 focus:outline-none focus:ring-1 focus:ring-amber-500" />
                  {kKalip && <button onClick={() => setKKalip("")} data-testid="kalite-filter-kalip-clear"
                    className="absolute right-1.5 top-1/2 -translate-y-1/2 text-zinc-400 hover:text-white text-sm leading-none">×</button>}
                </div>
                <div className="relative">
                  <input value={kUrun} onChange={(e) => setKUrun(e.target.value)} data-testid="kalite-filter-urun"
                    placeholder="Ürün kodu ile filtrele"
                    className="w-44 bg-white/10 border border-white/15 text-white placeholder:text-zinc-500 text-xs rounded-sm pl-2.5 pr-6 py-1.5 focus:outline-none focus:ring-1 focus:ring-amber-500" />
                  {kUrun && <button onClick={() => setKUrun("")} data-testid="kalite-filter-urun-clear"
                    className="absolute right-1.5 top-1/2 -translate-y-1/2 text-zinc-400 hover:text-white text-sm leading-none">×</button>}
                </div>
              </div>
              <div className="ml-auto flex items-center gap-2">
                <button onClick={exportKaliteExcel} data-testid="kalite-excel-btn" className="flex items-center gap-1.5 bg-green-600/90 hover:bg-green-600 text-white text-xs font-semibold px-2.5 py-1.5 rounded-sm"><FileDown size={14} /> Excel</button>
                <button onClick={exportKalitePdf} data-testid="kalite-pdf-btn" className="flex items-center gap-1.5 bg-white/10 hover:bg-white/20 text-white text-xs font-semibold px-2.5 py-1.5 rounded-sm"><Printer size={14} /> PDF</button>
              </div>
            </div>
            {(() => {
              const hr = hataRows();
              if (!hr.length) return null;
              const top = hr[0];
              return (
                <button onClick={() => openKalite(top.key, top.ad)} data-testid="en-sorunlu-neden"
                  className="group/esn flex items-center gap-2.5 mb-5 w-full sm:w-auto bg-red-500/10 hover:bg-red-500/20 border border-red-400/30 rounded-lg px-4 py-2.5 transition-colors text-left">
                  <AlertTriangle size={18} className="text-red-400 shrink-0" />
                  <div className="flex flex-col">
                    <span className="text-[10px] uppercase tracking-widest text-red-300/80 font-semibold">
                      En Sorunlu Neden{kFiltreMetni ? ` · ${kFiltreMetni}` : " · Genel"}
                    </span>
                    <span className="text-sm text-white font-bold">
                      {top.ad}
                      <span className="ml-2 num text-red-300">{fmt(top.adet)}</span>
                      <span className="ml-1.5 text-xs text-red-300/70">(%{hPctNum(top.adet)})</span>
                    </span>
                  </div>
                </button>
              );
            })()}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-center">
              <div className="lg:col-span-2 grid grid-cols-2 gap-4">
                <BigStat label="Toplam" value={fmt(kal?.toplam)} accent="text-white" sub="kalite kaydı adedi" onClick={() => openKalite("toplam", "Toplam Kalite Kaydı")} testid="kalite-stat-toplam" />
                <BigStat label="1. Kalite" value={fmt(kt.kalite1)} accent="text-emerald-400" sub={kPct(kt.kalite1)} onClick={() => openKalite("kalite1", "1. Kalite")} testid="kalite-stat-kalite1" />
                <BigStat label="2. Kalite" value={fmt(kt.kalite2)} accent="text-sky-400" sub={kPct(kt.kalite2)} onClick={() => openKalite("kalite2", "2. Kalite")} testid="kalite-stat-kalite2" />
                <BigStat label="Fire" value={fmt(kt.fire)} accent="text-red-400" sub={kPct(kt.fire)} onClick={() => openKalite("fire", "Fire")} testid="kalite-stat-fire" />
                <BigStat label="Toplam Geçen KG" value={fmt(kal?.toplam_kg)} accent="text-amber-400" sub="kg" onClick={() => openKalite("kg", "Toplam Geçen KG (ürün bazında)")} testid="kalite-stat-kg" />
              </div>
              <div className="relative cursor-pointer" style={{ height: 220 }} data-testid="verim-gauge" onClick={() => openKalite("kalite1", "1. Kalite")}>
                <ResponsiveContainer width="100%" height={220}>
                  <RadialBarChart innerRadius="72%" outerRadius="100%" startAngle={90} endAngle={-270}
                    data={[{ name: "Verim", value: kal?.fire_orani ?? 0 }]}>
                    <PolarAngleAxis type="number" domain={[0, 100]} tick={false} />
                    <RadialBar dataKey="value" cornerRadius={20} fill="#F59E0B" background={{ fill: "#3f3f46" }} />
                  </RadialBarChart>
                </ResponsiveContainer>
                <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
                  <div className="font-head font-black text-4xl text-amber-400 num">%{kal?.fire_orani ?? 0}</div>
                  <div className="text-[11px] uppercase tracking-widest text-zinc-400 mt-1">1. Kalite Verimi</div>
                </div>
              </div>
            </div>
            {(() => {
              const base = kTop || 1;
              const KALITE_GRADE = ["kalite1", "kalite2", "kalite3", "fire"];
              const kd = KALITE_ALANLARI.map((f) => ({ key: f.key, ad: f.label, adet: kt[f.key] || 0 }))
                .filter((e) => e.adet > 0 && (KALITE_GRADE.includes(e.key) || e.adet < base));
              return (
                <div className="mt-6">
                  <div className="flex justify-between text-[11px] uppercase tracking-widest text-zinc-400 mb-2">
                    <span>Kalite Dağılımı (kategoriye tıkla)</span><span className="num">{fmt(kTop)} adet</span>
                  </div>
                  <div className="flex h-4 w-full overflow-hidden rounded-full bg-white/10">
                    {kd.map((e, i) => (
                      <div key={i} style={{ width: `${(e.adet / base * 100).toFixed(1)}%`, background: COLORS[i % COLORS.length] }}
                        title={`${e.ad}: ${fmt(e.adet)}`} />
                    ))}
                  </div>
                  <div className="flex flex-wrap gap-4 mt-3">
                    {kd.map((e, i) => (
                      <button key={i} onClick={() => openKalite(e.key, e.ad)} data-testid={`kalite-legend-${e.key}`}
                        className="flex items-center gap-1.5 text-xs text-zinc-300 hover:text-white">
                        <span className="w-2.5 h-2.5 rounded-full" style={{ background: COLORS[i % COLORS.length] }} />
                        {e.ad} <span className="font-bold text-white num">{fmt(e.adet)}</span>
                        <span className="text-zinc-500">(%{(e.adet / base * 100).toFixed(1)})</span>
                      </button>
                    ))}
                  </div>
                </div>
              );
            })()}
          </div>
        </div>

        {/* KALAN SİPARİŞ ÖZETİ */}
        <div className="group relative overflow-hidden rounded-lg bg-gradient-to-br from-zinc-900 via-zinc-900 to-zinc-800 p-6 shadow-xl">
          <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-sky-500/10 blur-3xl" />
          <div className="pointer-events-none absolute -left-12 -bottom-12 h-44 w-44 rounded-full bg-amber-400/10 blur-2xl" />
          <div className="relative">
            <div className="flex items-center gap-2 mb-6 flex-wrap">
              <ClipboardList className="text-amber-400" size={18} />
              <h3 className="font-head font-black uppercase tracking-[0.2em] text-white text-sm">Kalan Sipariş Özeti</h3>
              <div className="ml-auto inline-flex rounded-full bg-white/5 border border-white/10 p-0.5" data-testid="horeca-filter">
                {[
                  { id: "all", ad: "Tümü" },
                  { id: "ihracat", ad: "İhracat" },
                  { id: "ic", ad: "İç Piyasa" },
                ].map((o) => (
                  <button key={o.id} onClick={() => setHorecaF(o.id)} data-testid={`horeca-filter-${o.id}`}
                    className={`px-3 py-1 rounded-full text-[11px] font-bold uppercase tracking-wide transition-colors ${horecaF === o.id ? "bg-amber-500 text-zinc-900" : "text-zinc-300 hover:text-white"}`}>
                    {o.ad}
                  </button>
                ))}
              </div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-stretch">
              <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div className="rounded-md bg-white/5 border border-white/10 px-4 py-4 backdrop-blur cursor-pointer hover:-translate-y-0.5 hover:ring-1 hover:ring-amber-500/50 transition-all"
                  data-testid="horeca-card" onClick={() => openSiparis("horeca", "Horeca Kalan Siparişler")}>
                  <div className="flex items-center gap-1 text-[11px] font-semibold uppercase tracking-widest text-zinc-400">
                    HORECA{horecaF === "ihracat" ? " — İHRACAT" : horecaF === "ic" ? " — İÇ PIYASA" : ""}
                    <ChevronRight size={12} className="text-amber-400/60" />
                  </div>
                  <div className="font-head font-black text-3xl mt-1 num text-sky-400" data-testid="horeca-value">
                    {fmt(horecaF === "ihracat" ? dag?.horeca_ihracat : horecaF === "ic" ? dag?.horeca_ic_piyasa : dag?.horeca)}
                  </div>
                  <div className="text-[11px] text-zinc-500 mt-0.5">
                    {horecaF === "all" ? "satış noktası: horeca" : `horeca içi: ${horecaF === "ihracat" ? "ihracat" : "iç piyasa"}`}
                  </div>
                  <div className="mt-3 pt-3 border-t border-white/10 space-y-1.5">
                    <button onClick={(e) => { e.stopPropagation(); openSiparis("ihracat", "Horeca — İhracat Kalan Siparişler"); }} data-testid="horeca-ihracat"
                      className={`w-full flex items-center justify-between text-xs rounded px-1 -mx-1 hover:bg-white/10 ${horecaF === "ihracat" ? "bg-emerald-500/10" : ""}`}>
                      <span className="text-zinc-400 uppercase tracking-wide">İhracat</span>
                      <span className="font-head font-black num text-emerald-400">{fmt(dag?.horeca_ihracat)}</span>
                    </button>
                    <button onClick={(e) => { e.stopPropagation(); openSiparis("ic", "Horeca — İç Piyasa Kalan Siparişler"); }} data-testid="horeca-ic-piyasa"
                      className={`w-full flex items-center justify-between text-xs rounded px-1 -mx-1 hover:bg-white/10 ${horecaF === "ic" ? "bg-amber-500/10" : ""}`}>
                      <span className="text-zinc-400 uppercase tracking-wide">İç Piyasa</span>
                      <span className="font-head font-black num text-amber-400">{fmt(dag?.horeca_ic_piyasa)}</span>
                    </button>
                  </div>
                </div>
                <BigStat label="FASON" value={fmt(dag?.fason)} accent="text-amber-400" sub="satış noktası: fason" onClick={() => openSiparis("fason", "Fason Kalan Siparişler")} testid="siparis-stat-fason" />
                <BigStat label="DİĞER" value={fmt(dag?.diger)} accent="text-zinc-200" sub="diğer / tanımsız" onClick={() => openSiparis("diger", "Diğer Kalan Siparişler")} testid="siparis-stat-diger" />
              </div>
              <div className="rounded-md bg-amber-500/10 border border-amber-400/30 px-4 py-5 flex flex-col items-center justify-center text-center cursor-pointer hover:ring-1 hover:ring-amber-400/60 transition-all"
                data-testid="siparis-stat-toplam" onClick={() => openSiparis("all", "Tüm Kalan Siparişler")}>
                <div className="flex items-center gap-1 text-[11px] font-semibold uppercase tracking-widest text-amber-300">Toplam Sipariş Adeti <ChevronRight size={12} /></div>
                <div className="font-head font-black text-4xl num text-amber-400 mt-1">{fmt(dag?.toplam)}</div>
                <div className="text-[11px] text-zinc-400 mt-1">Horeca + Fason + Diğer</div>
                <div className="mt-3 pt-3 border-t border-amber-400/20 w-full">
                  <div className="text-[11px] font-semibold uppercase tracking-widest text-amber-300">Toplam KG</div>
                  <div className="font-head font-black text-2xl num text-white mt-0.5">{fmt(dag?.toplam_kg)}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <FirinSiparisRaporu />

        <SiparisIsBolumuRaporu />

        {/* BÖLÜM KIRILIMI & VARDİYA ÖZETİ */}
        <div className="rounded-lg bg-gradient-to-br from-zinc-900 via-zinc-900 to-zinc-800 p-6 shadow-xl">
          <div className="flex items-center gap-2 mb-5 flex-wrap">
            <Factory className="text-amber-400" size={18} />
            <h3 className="font-head font-black uppercase tracking-[0.2em] text-white text-sm">Yapılan Ürün — Bölüm & Vardiya Özeti</h3>
            <div className="ml-auto flex items-end gap-2 no-print">
              <button onClick={indirAylikRapor} data-testid="ay-rapor-btn"
                className="flex items-center gap-1.5 bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-bold px-2.5 py-1.5 rounded transition-colors">
                <FileDown size={13} /> Bu Ayın Raporu
              </button>
              {user?.role === "admin" && (
                <button onClick={openHedef} data-testid="bolum-hedef-btn"
                  className="flex items-center gap-1.5 bg-sky-500/15 border border-sky-400/30 text-sky-300 hover:bg-sky-500/25 text-xs font-semibold px-2.5 py-1.5 rounded transition-colors">
                  <ClipboardList size={13} /> Hedefler
                </button>
              )}
              <button onClick={exportOzetExcel} data-testid="ozet-excel-btn"
                className="flex items-center gap-1.5 bg-emerald-500/15 border border-emerald-400/30 text-emerald-300 hover:bg-emerald-500/25 text-xs font-semibold px-2.5 py-1.5 rounded transition-colors">
                <FileDown size={13} /> Excel
              </button>
              <button onClick={exportOzetPdf} data-testid="ozet-pdf-btn"
                className="flex items-center gap-1.5 bg-red-500/15 border border-red-400/30 text-red-300 hover:bg-red-500/25 text-xs font-semibold px-2.5 py-1.5 rounded transition-colors">
                <Printer size={13} /> PDF
              </button>
              <div>
                <label className="block text-[10px] uppercase tracking-widest text-zinc-400 mb-0.5">Başlangıç</label>
                <input type="date" value={ozetStart} onChange={(e) => setOzetStart(e.target.value)} data-testid="ozet-start"
                  className="bg-white/10 border border-white/15 rounded px-2 py-1 text-xs text-white [color-scheme:dark]" />
              </div>
              <div>
                <label className="block text-[10px] uppercase tracking-widest text-zinc-400 mb-0.5">Bitiş</label>
                <input type="date" value={ozetEnd} onChange={(e) => setOzetEnd(e.target.value)} data-testid="ozet-end"
                  className="bg-white/10 border border-white/15 rounded px-2 py-1 text-xs text-white [color-scheme:dark]" />
              </div>
              {(ozetStart || ozetEnd) && (
                <button onClick={() => { setOzetStart(""); setOzetEnd(""); }} data-testid="ozet-temizle"
                  className="text-[11px] text-amber-300 hover:text-amber-200 underline pb-1.5">Temizle</button>
              )}
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Bölüm kırılımı */}
            <div data-testid="bolum-kirilim-panel">
              <div className="text-[11px] uppercase tracking-widest text-zinc-400 mb-3">Bölüm Bazında Üretim (Toplam Adet)</div>
              {!bolum || (bolum.rows || []).length === 0 ? (
                <div className="py-8 text-center text-zinc-500 text-sm">Kayıt yok.</div>
              ) : (
                <div className="space-y-2.5">
                  {bolum.rows.map((b) => {
                    const pct = (!b.logo && bolum.genel_toplam > 0) ? Math.round((b.toplam / bolum.genel_toplam) * 100) : 0;
                    const hedef = Number(b.aylik_hedef) || 0;
                    const ger = hedef > 0 ? Math.round((b.toplam / hedef) * 100) : null;
                    return (
                      <div key={b.bolum} onClick={() => openYapilan("bolum", b.bolum, `Bölüm: ${b.bolum} — Yapılan Ürün Detayı`)}
                        className={`rounded-md border px-3 py-2.5 cursor-pointer hover:ring-1 hover:ring-amber-400/40 transition-all ${b.logo ? "bg-amber-500/10 border-amber-400/30" : "bg-white/5 border-white/10 hover:bg-white/10"}`} data-testid={`bolum-row-${b.bolum}`}>
                        <div className="flex items-center justify-between">
                          <span className="text-sm font-semibold text-white flex items-center gap-2">
                            {b.bolum}
                            {b.logo && <span className="text-[9px] font-semibold text-amber-300 bg-amber-500/15 border border-amber-400/30 rounded px-1.5 py-0.5">toplama dahil değil</span>}
                          </span>
                          <span className="font-head font-black num text-amber-400">{fmt(b.toplam)}{!b.logo && <span className="text-[11px] text-zinc-500"> %{pct}</span>}</span>
                        </div>
                        {!b.logo && (
                          <div className="h-2 w-full overflow-hidden rounded-full bg-white/10 my-1.5">
                            <div className="h-full bg-gradient-to-r from-amber-500 to-amber-400" style={{ width: `${Math.min(pct, 100)}%` }} />
                          </div>
                        )}
                        <div className={`flex items-center gap-4 text-[11px] text-zinc-400 ${b.logo ? "mt-1.5" : ""}`}>
                          <span>1.Kalite: <b className="text-emerald-400">{fmt(b.kalite1)}</b></span>
                          <span>Fire: <b className="text-red-400">{fmt(b.fire)}</b></span>
                          <span>KG: <b className="text-sky-300">{fmt(b.kg)}</b></span>
                          {hedef > 0 && (
                            <span className="ml-auto">Hedef(Aylık): <b className="text-sky-300">{fmt(hedef)}</b> · <b className={ger >= 100 ? "text-emerald-400" : ger >= 70 ? "text-amber-300" : "text-red-400"}>%{ger}</b></span>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            {/* Vardiya özeti */}
            <div data-testid="vardiya-ozeti-panel">
              <div className="text-[11px] uppercase tracking-widest text-zinc-400 mb-3">Vardiya Bazında Üretim / Fire / KG</div>
              {!vardiyaOzet || (vardiyaOzet.rows || []).length === 0 ? (
                <div className="py-8 text-center text-zinc-500 text-sm">Kayıt yok.</div>
              ) : (
                <div className="rounded-md border border-white/10 overflow-hidden">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-white/10 text-zinc-300 text-[11px] uppercase tracking-wide">
                        <th className="text-left px-3 py-2">Vardiya</th>
                        <th className="text-right px-3 py-2">Üretim</th>
                        <th className="text-right px-3 py-2">Fire</th>
                        <th className="text-right px-3 py-2">KG</th>
                      </tr>
                    </thead>
                    <tbody>
                      {vardiyaOzet.rows.map((v) => (
                        <tr key={v.vardiya} onClick={() => openYapilan("vardiya", v.vardiya, `Vardiya: ${v.vardiya} — Yapılan Ürün Detayı`)}
                          className="border-t border-white/5 cursor-pointer hover:bg-white/10 transition-colors" data-testid={`vardiya-row-${v.vardiya}`}>
                          <td className="px-3 py-2 text-white font-semibold">{v.vardiya}</td>
                          <td className="px-3 py-2 text-right num text-amber-400 font-bold">{fmt(v.uretim)}</td>
                          <td className="px-3 py-2 text-right num text-red-400">{fmt(v.fire)}</td>
                          <td className="px-3 py-2 text-right num text-sky-300">{fmt(v.kg)}</td>
                        </tr>
                      ))}
                      <tr className="border-t-2 border-white/20 bg-white/5 font-bold" data-testid="vardiya-toplam-row">
                        <td className="px-3 py-2 text-zinc-200 uppercase text-xs tracking-wide">Toplam</td>
                        <td className="px-3 py-2 text-right num text-amber-300">{fmt(vardiyaOzet.toplam_uretim)}</td>
                        <td className="px-3 py-2 text-right num text-red-300">{fmt(vardiyaOzet.toplam_fire)}</td>
                        <td className="px-3 py-2 text-right num text-sky-200">{fmt(vardiyaOzet.toplam_kg)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* ŞEKİLLENEN ÜRÜN — MAKİNE BAZINDA (Kalite Takibi Özeti altında) */}
        <div className="group relative overflow-hidden rounded-lg bg-gradient-to-br from-zinc-900 via-zinc-900 to-zinc-800 p-6 shadow-xl">
          <img src={FAB_IMGS[0]} alt="" className="pointer-events-none absolute right-0 top-0 h-full w-1/3 object-cover opacity-25" />
          <div className="pointer-events-none absolute -left-12 -bottom-12 h-44 w-44 rounded-full bg-amber-400/10 blur-2xl" />
          <div className="relative">
            <div className="flex items-center gap-2 mb-6">
              <Factory className="text-amber-400" size={18} />
              <h3 className="font-head font-black uppercase tracking-[0.2em] text-white text-sm">Şekillenen Ürün — Makine Bazında</h3>
              <DateFilter start={mStart} end={mEnd} setStart={setMStart} setEnd={setMEnd} testidPrefix="makine" />
              <MakineOzetExport rows={sekMak} start={mStart} end={mEnd} />
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="text-left text-[11px] uppercase tracking-widest text-zinc-400 border-b border-white/10">
                    <th className="py-2 pr-4">Makine</th>
                    <th className="py-2 px-3 text-right">Şekillenen</th>
                    <th className="py-2 px-3 text-right">Defo</th>
                    <th className="py-2 px-3 text-right">Defo Oranı</th>
                    <th className="py-2 px-3 text-right">Net (Slim)</th>
                    <th className="py-2 px-3 text-right">Brüt Şekillenen</th>
                    <th className="py-2 px-3 text-right">KG</th>
                    <th className="py-2 px-3 text-right">Hedef (Kapasite)</th>
                    <th className="py-2 px-3 text-right">Gerçekleşme</th>
                  </tr>
                </thead>
                <tbody>
                  {sekMak.map((r, i) => (
                    <tr key={i} onClick={() => openMakine(r)} className="border-b border-white/5 hover:bg-white/5 cursor-pointer transition-colors" data-testid={`makina-row-${i}`}>
                      <td className="py-2.5 pr-4">
                        <div className="flex items-center gap-2.5">
                          <img src={FAB_IMGS[i % FAB_IMGS.length]} alt="" className="h-14 w-14 rounded-md object-cover ring-1 ring-white/20 shadow-md" />
                          <span className="font-semibold text-white">{r.makina}</span>
                        </div>
                      </td>
                      <td className="py-2.5 px-3 text-right num text-white">{fmt(r.sekillenen)}</td>
                      <td className="py-2.5 px-3 text-right num text-red-400">{fmt(r.defo)}</td>
                      <td className="py-2.5 px-3 text-right">{(() => {
                        const p = Number(r.defo_orani) || 0;
                        const cls = p >= 10 ? "bg-red-500/20 text-red-300" : p >= 5 ? "bg-amber-500/20 text-amber-300" : "bg-emerald-500/20 text-emerald-300";
                        return <span className={`inline-block rounded px-2 py-0.5 text-xs font-bold ${cls}`} data-testid={`makina-defo-orani-${i}`}>%{fmt(p)}</span>;
                      })()}</td>
                      <td className="py-2.5 px-3 text-right num text-emerald-400 font-bold">{fmt(r.net)}</td>
                      <td className="py-2.5 px-3 text-right num text-sky-300">{fmt(r.brut)}</td>
                      <td className="py-2.5 px-3 text-right num text-amber-400">{fmt(r.kg)}</td>
                      <td className="py-2.5 px-3 text-right num text-sky-300">{r.kapasite ? fmt(r.hedef) : "—"}</td>
                      <td className="py-2.5 px-3 text-right">
                        {r.kapasite ? (() => {
                          const p = Number(r.yuzde) || 0;
                          const cls = p >= 100 ? "bg-emerald-500/20 text-emerald-300" : p >= 70 ? "bg-amber-500/20 text-amber-300" : "bg-red-500/20 text-red-300";
                          return <span className={`inline-block rounded px-2 py-0.5 text-xs font-bold ${cls}`} data-testid={`makina-yuzde-${i}`}>%{fmt(p)}</span>;
                        })() : <span className="text-zinc-600 text-xs">kapasite yok</span>}
                      </td>
                    </tr>
                  ))}
                  {sekMak.length === 0 && (
                    <tr><td colSpan={9} className="py-6 text-center text-zinc-500">Şekillenen ürün kaydı yok.</td></tr>
                  )}
                </tbody>
                {sekMak.length > 0 && (
                  <tfoot>
                    <tr className="border-t border-white/20 font-bold text-white">
                      <td className="py-2.5 pr-4 uppercase text-[11px] tracking-widest text-amber-400">Toplam</td>
                      <td className="py-2.5 px-3 text-right num">{fmt(sekMak.reduce((a, b) => a + b.sekillenen, 0))}</td>
                      <td className="py-2.5 px-3 text-right num text-red-400">{fmt(sekMak.reduce((a, b) => a + b.defo, 0))}</td>
                      <td className="py-2.5 px-3 text-right">{(() => {
                        const td = sekMak.reduce((a, b) => a + b.defo, 0);
                        const ts = sekMak.reduce((a, b) => a + b.sekillenen, 0);
                        const p = ts ? Math.round(td / ts * 1000) / 10 : 0;
                        const cls = p >= 10 ? "text-red-300" : p >= 5 ? "text-amber-300" : "text-emerald-300";
                        return <span className={`num font-bold ${cls}`} data-testid="makina-defo-orani-toplam">%{fmt(p)}</span>;
                      })()}</td>
                      <td className="py-2.5 px-3 text-right num text-emerald-400">{fmt(sekMak.reduce((a, b) => a + b.net, 0))}</td>
                      <td className="py-2.5 px-3 text-right num text-sky-300">{fmt(sekMak.reduce((a, b) => a + (b.brut || 0), 0))}</td>
                      <td className="py-2.5 px-3 text-right num text-amber-400">{fmt(Math.round(sekMak.reduce((a, b) => a + b.kg, 0)))}</td>
                      <td className="py-2.5 px-3 text-right num text-sky-300">{fmt(sekMak.reduce((a, b) => a + (b.hedef || 0), 0))}</td>
                      <td className="py-2.5 px-3 text-right">
                        {(() => {
                          const th = sekMak.reduce((a, b) => a + (b.hedef || 0), 0);
                          const tn = sekMak.reduce((a, b) => a + b.net, 0);
                          const p = th ? Math.round(tn / th * 1000) / 10 : 0;
                          const cls = p >= 100 ? "text-emerald-300" : p >= 70 ? "text-amber-300" : "text-red-300";
                          return <span className={`num ${cls}`} data-testid="makina-yuzde-toplam">{th ? `%${fmt(p)}` : "—"}</span>;
                        })()}
                      </td>
                    </tr>
                  </tfoot>
                )}
              </table>
            </div>
          </div>
        </div>

        {/* ÜRETİM PLANLAMA GERÇEKLEŞME */}
        <div className="group relative overflow-hidden rounded-lg bg-gradient-to-br from-zinc-900 via-zinc-900 to-zinc-800 p-6 shadow-xl">
          <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-emerald-500/10 blur-3xl" />
          <div className="pointer-events-none absolute -left-12 -bottom-12 h-44 w-44 rounded-full bg-amber-400/10 blur-2xl" />
          <div className="relative">
            <div className="flex items-center gap-2 mb-5 flex-wrap">
              <ClipboardList className="text-amber-400" size={18} />
              <h3 className="font-head font-black uppercase tracking-[0.2em] text-white text-sm">Üretim Planlama Gerçekleşme</h3>
              <div className="ml-auto flex items-end gap-2 no-print">
                <div>
                  <label className="block text-[10px] uppercase tracking-widest text-zinc-400 mb-0.5">Başlangıç</label>
                  <input type="date" value={planStart} onChange={(e) => setPlanStart(e.target.value)} data-testid="plan-start"
                    className="bg-white/10 border border-white/15 rounded px-2 py-1 text-xs text-white [color-scheme:dark]" />
                </div>
                <div>
                  <label className="block text-[10px] uppercase tracking-widest text-zinc-400 mb-0.5">Bitiş</label>
                  <input type="date" value={planEnd} onChange={(e) => setPlanEnd(e.target.value)} data-testid="plan-end"
                    className="bg-white/10 border border-white/15 rounded px-2 py-1 text-xs text-white [color-scheme:dark]" />
                </div>
                {(planStart || planEnd) && (
                  <button onClick={() => { setPlanStart(""); setPlanEnd(""); }} data-testid="plan-filtre-temizle"
                    className="text-[11px] text-amber-300 hover:text-amber-200 underline pb-1.5">Temizle</button>
                )}
              </div>
            </div>
            {!planDetay ? (
              <div className="py-10 text-center text-zinc-500 text-sm"><Loader2 className="animate-spin inline" size={16} /> Yükleniyor...</div>
            ) : (
              <>
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-center">
                  <div className="relative cursor-pointer" style={{ height: 200 }} data-testid="plan-gauge" onClick={() => openPlan("all", "Tüm Plan Kalemleri (filtreli)")}>
                    <ResponsiveContainer width="100%" height={200}>
                      <RadialBarChart innerRadius="72%" outerRadius="100%" startAngle={90} endAngle={-270}
                        data={[{ name: "Oran", value: planSum.oran }]}>
                        <PolarAngleAxis type="number" domain={[0, 100]} tick={false} />
                        <RadialBar dataKey="value" cornerRadius={20} fill="#34D399" background={{ fill: "#3f3f46" }} />
                      </RadialBarChart>
                    </ResponsiveContainer>
                    <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
                      <div className="font-head font-black text-4xl text-emerald-400 num" data-testid="plan-oran">%{planSum.oran}</div>
                      <div className="text-[11px] uppercase tracking-widest text-zinc-400 mt-1">Gerçekleşme</div>
                    </div>
                  </div>
                  <div className="lg:col-span-2 space-y-3">
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-zinc-400">Planlanan</span>
                      <span className="font-head font-black text-xl num text-white">{fmt(planSum.planlanan)}</span>
                    </div>
                    <div className="h-3 w-full overflow-hidden rounded-full bg-white/10">
                      <div className="h-full bg-gradient-to-r from-emerald-500 to-emerald-400" style={{ width: `${Math.min(planSum.oran, 100)}%` }} />
                    </div>
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-zinc-400">Yapılan (plan dahilinde)</span>
                      <span className="font-head font-black text-xl num text-emerald-400">{fmt(planSum.yapilan)}</span>
                    </div>
                    <div className="grid grid-cols-3 gap-3 pt-2">
                      <button onClick={() => openPlan("Yapıldı", "Tamamlanan Plan Kalemleri")} data-testid="plan-stat-tamamlanan"
                        className="rounded-md bg-emerald-500/10 border border-emerald-400/30 px-3 py-3 text-center cursor-pointer hover:ring-1 hover:ring-emerald-400/60 transition-all">
                        <div className="font-head font-black text-2xl num text-emerald-400">{fmt(planSum.tamamlanan)}</div>
                        <div className="text-[11px] uppercase tracking-wide text-emerald-300 mt-0.5">Tamamlanan</div>
                      </button>
                      <button onClick={() => openPlan("Kısmi", "Kısmi Yapılan Plan Kalemleri")} data-testid="plan-stat-kismi"
                        className="rounded-md bg-amber-500/10 border border-amber-400/30 px-3 py-3 text-center cursor-pointer hover:ring-1 hover:ring-amber-400/60 transition-all">
                        <div className="font-head font-black text-2xl num text-amber-400">{fmt(planSum.kismi)}</div>
                        <div className="text-[11px] uppercase tracking-wide text-amber-300 mt-0.5">Kısmi</div>
                      </button>
                      <button onClick={() => openPlan("Yapılmadı", "Yapılmayan Plan Kalemleri")} data-testid="plan-stat-yapilmayan"
                        className="rounded-md bg-red-500/10 border border-red-400/30 px-3 py-3 text-center cursor-pointer hover:ring-1 hover:ring-red-400/60 transition-all">
                        <div className="font-head font-black text-2xl num text-red-400">{fmt(planSum.yapilmayan)}</div>
                        <div className="text-[11px] uppercase tracking-wide text-red-300 mt-0.5">Yapılmayan</div>
                      </button>
                    </div>
                    <div className="text-[11px] text-zinc-500 pt-1">Toplam {fmt(planSum.toplam)} plan kalemi{(planStart || planEnd) ? " (tarih filtreli)" : ""}</div>
                  </div>
                </div>

                {/* Günlük Gerçekleşme (%) */}
                <div className="mt-6">
                  <div className="flex justify-between text-[11px] uppercase tracking-widest text-zinc-400 mb-2">
                    <span>Günlük Gerçekleşme (%)</span><span className="num">{planDays.length} gün</span>
                  </div>
                  <div className="space-y-2.5 max-h-64 overflow-auto pr-1" data-testid="plan-gunluk">
                    {planDays.map((d) => {
                      const bar = d.oran >= 100 ? "from-emerald-500 to-emerald-400" : d.oran > 0 ? "from-amber-500 to-amber-400" : "from-red-500 to-red-400";
                      return (
                        <button key={d.tarih} onClick={() => openPlan("all", `${trTarih(d.tarih)} — Plan Kalemleri`, d.tarih)} data-testid={`plan-gun-${d.tarih}`}
                          className="w-full text-left rounded-md px-1 py-1 hover:bg-white/5 transition-colors">
                          <div className="flex items-center justify-between text-xs mb-1">
                            <span className="text-zinc-200 num font-semibold whitespace-nowrap">{trTarih(d.tarih)}</span>
                            <span className="text-[11px] text-zinc-400">
                              Plan <span className="text-white num">{fmt(d.planlanan)}</span> · Yapılan <span className="text-emerald-400 num">{fmt(d.yapilan)}</span>
                              <span className="ml-2 text-emerald-300">✓{d.tamamlanan}</span>
                              <span className="ml-1 text-amber-300">◐{d.kismi}</span>
                              <span className="ml-1 text-red-300">✕{d.yapilmayan}</span>
                              <span className="ml-2 font-head font-black text-white">%{d.oran}</span>
                            </span>
                          </div>
                          <div className="h-2.5 w-full overflow-hidden rounded-full bg-white/10">
                            <div className={`h-full bg-gradient-to-r ${bar}`} style={{ width: `${Math.min(d.oran, 100)}%` }} />
                          </div>
                        </button>
                      );
                    })}
                    {planDays.length === 0 && <div className="text-center text-zinc-500 text-sm py-6">Seçilen tarih aralığında plan kalemi yok.</div>}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        {/* TERMİN DURUMU */}
        <div className="group relative overflow-hidden rounded-lg bg-gradient-to-br from-zinc-900 via-zinc-900 to-zinc-800 p-6 shadow-xl">
          <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-red-500/10 blur-3xl" />
          <div className="pointer-events-none absolute -left-12 -bottom-12 h-44 w-44 rounded-full bg-emerald-400/10 blur-2xl" />
          <div className="relative">
            <div className="flex items-center gap-2 mb-6">
              <CalendarClock className="text-amber-400" size={18} />
              <h3 className="font-head font-black uppercase tracking-[0.2em] text-white text-sm">Termin Durumu</h3>
              <span className="ml-auto text-[11px] uppercase tracking-widest text-amber-400/80">Duruma tıkla → detay</span>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-1 gap-4">
                <button onClick={() => openTermin("gecti", "Termini Geçen Siparişler")} data-testid="termin-gecti"
                  className="rounded-md bg-red-500/10 border border-red-400/30 px-4 py-4 text-left cursor-pointer hover:ring-1 hover:ring-red-400/60 transition-all">
                  <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-red-300">
                    <span className="w-2 h-2 rounded-full bg-red-500" /> Termini Geçen <ChevronRight size={12} className="ml-auto" />
                  </div>
                  <div className="font-head font-black text-3xl mt-1 num text-red-400">{fmt(terminCounts.gecti)}</div>
                </button>
                <button onClick={() => openTermin("yaklasiyor", "Termini Yaklaşan Siparişler")} data-testid="termin-yaklasiyor"
                  className="rounded-md bg-emerald-500/10 border border-emerald-400/30 px-4 py-4 text-left cursor-pointer hover:ring-1 hover:ring-emerald-400/60 transition-all">
                  <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-emerald-300">
                    <span className="w-2 h-2 rounded-full bg-emerald-500" /> Termini Yaklaşan <ChevronRight size={12} className="ml-auto" />
                  </div>
                  <div className="font-head font-black text-3xl mt-1 num text-emerald-400">{fmt(terminCounts.yaklasiyor)}</div>
                </button>
                <button onClick={() => openTermin("uzak", "Termini Uzak Siparişler")} data-testid="termin-uzak"
                  className="rounded-md bg-sky-500/10 border border-sky-400/30 px-4 py-4 text-left cursor-pointer hover:ring-1 hover:ring-sky-400/60 transition-all">
                  <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-sky-300">
                    <span className="w-2 h-2 rounded-full bg-sky-500" /> Termini Uzak <ChevronRight size={12} className="ml-auto" />
                  </div>
                  <div className="font-head font-black text-3xl mt-1 num text-sky-400">{fmt(terminCounts.uzak)}</div>
                </button>
              </div>
              <div className="lg:col-span-2">
                <div className="flex items-center justify-between text-[11px] uppercase tracking-widest text-zinc-400 mb-2">
                  <span>En Yakın Terminler</span>
                  <button onClick={() => openTermin("all", "Tüm Termin Kayıtları")} className="text-amber-300 hover:text-amber-200 inline-flex items-center gap-1" data-testid="termin-tumu">Tümü <ChevronRight size={12} /></button>
                </div>
                <div className="rounded-md bg-white/5 border border-white/10 overflow-hidden">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="text-left text-[11px] uppercase tracking-widest text-zinc-400 border-b border-white/10">
                        <th className="py-2 px-3">Termin</th>
                        <th className="py-2 px-3">Müşteri</th>
                        <th className="py-2 px-3">Ürün</th>
                        <th className="py-2 px-3 text-right">Kalan</th>
                        <th className="py-2 px-3">Süre</th>
                      </tr>
                    </thead>
                    <tbody>
                      {terminEnYakin.map((t, i) => {
                        const cfg = TCFG[t.termin_durum] || {};
                        return (
                          <tr key={t.id || i} onClick={() => openTermin(t.termin_durum, cfg.label || "Termin")} className="border-b border-white/5 cursor-pointer hover:bg-white/5" data-testid={`termin-mini-${i}`}>
                            <td className="py-2 px-3 num text-white whitespace-nowrap">{trTarih(t.termin_tarihi)}</td>
                            <td className="py-2 px-3 text-zinc-300 truncate max-w-[160px]">{t.musteri || "—"}</td>
                            <td className="py-2 px-3 text-zinc-300 whitespace-nowrap">{t.urun_kodu}</td>
                            <td className="py-2 px-3 text-right num text-amber-400">{fmt(t.kalan)}</td>
                            <td className={`py-2 px-3 text-xs font-semibold whitespace-nowrap ${cfg.txt || "text-zinc-400"}`}>{gunLabel(t.kalan_gun)}</td>
                          </tr>
                        );
                      })}
                      {terminEnYakin.length === 0 && (
                        <tr><td colSpan={5} className="py-6 text-center text-zinc-500">Termin kaydı yok.</td></tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        {gecikmeTrend.length > 0 && (
          <div className="rounded-lg border border-zinc-200 bg-white p-5" data-testid="gecikme-trend-card">
            <h3 className="font-head font-bold text-sm uppercase tracking-wide text-zinc-700 mb-3">Gecikmiş Parti Trendi (Üretim Gününe Göre)</h3>
            <ResponsiveContainer width="100%" height={260}>
              <ComposedChart data={gecikmeTrend} margin={{ top: 5, right: 10, left: -10, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                <XAxis dataKey="tarih" tick={{ fontSize: 11 }} tickFormatter={(t) => { const p = String(t).slice(5).split("-"); return p.length === 2 ? `${p[1]}.${p[0]}` : t; }} />
                <YAxis yAxisId="l" tick={{ fontSize: 11 }} allowDecimals={false} />
                <YAxis yAxisId="r" orientation="right" tick={{ fontSize: 11 }} />
                <Tooltip />
                <Legend />
                <Bar yAxisId="l" dataKey="gecikmis" name="Gecikmiş Parti" fill="#ef4444" radius={[3, 3, 0, 0]} />
                <Line yAxisId="r" type="monotone" dataKey="kalan" name="Kalan Adet" stroke="#f59e0b" strokeWidth={2} dot={false} />
              </ComposedChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>

      {hedefOpen && (
        <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/60 p-4 overflow-y-auto" onMouseDown={() => setHedefOpen(false)}>
          <div className="bg-white rounded-lg shadow-2xl w-full max-w-lg my-8" onMouseDown={(e) => e.stopPropagation()} data-testid="hedef-modal">
            <div className="flex items-center justify-between border-b border-zinc-200 px-5 py-3 bg-zinc-900 rounded-t-lg">
              <h3 className="font-head font-black text-white uppercase tracking-widest text-sm">Bölüm Hedefleri (Adet)</h3>
              <button onClick={() => setHedefOpen(false)} className="text-zinc-400 hover:text-white"><X size={18} /></button>
            </div>
            <div className="p-5 space-y-3">
              <div className="grid grid-cols-[1fr_auto_auto] gap-3 items-center text-[11px] font-semibold uppercase tracking-wide text-zinc-500">
                <span>Bölüm</span><span className="w-28 text-center">Günlük Hedef</span><span className="w-28 text-center">Aylık Hedef</span>
              </div>
              {BOLUM_OPTS.map((b) => (
                <div key={b} className="grid grid-cols-[1fr_auto_auto] gap-3 items-center">
                  <span className="text-sm font-semibold text-zinc-800">{b}</span>
                  <input type="number" value={hedefForm[b]?.gunluk_hedef ?? ""} data-testid={`hedef-gunluk-${b}`}
                    onChange={(e) => setHedefForm((s) => ({ ...s, [b]: { ...s[b], gunluk_hedef: e.target.value } }))}
                    className="w-28 border border-zinc-300 rounded-sm px-2 py-1.5 text-sm mono focus:outline-none focus:ring-2 focus:ring-sky-600" />
                  <input type="number" value={hedefForm[b]?.aylik_hedef ?? ""} data-testid={`hedef-aylik-${b}`}
                    onChange={(e) => setHedefForm((s) => ({ ...s, [b]: { ...s[b], aylik_hedef: e.target.value } }))}
                    className="w-28 border border-zinc-300 rounded-sm px-2 py-1.5 text-sm mono focus:outline-none focus:ring-2 focus:ring-sky-600" />
                </div>
              ))}
              <p className="text-[11px] text-zinc-400 pt-1">Gerçekleşme %, seçili tarih aralığındaki toplam üretimin aylık hedefe oranıdır. Logo bölümü toplamlara dahil edilmez.</p>
            </div>
            <div className="flex justify-end gap-2 border-t border-zinc-200 px-5 py-3">
              <button onClick={() => setHedefOpen(false)} className="px-4 py-2 text-sm border border-zinc-300 rounded-sm hover:bg-zinc-50">İptal</button>
              <button onClick={saveHedef} data-testid="hedef-save-btn" className="px-4 py-2 text-sm bg-sky-600 hover:bg-sky-700 text-white font-semibold rounded-sm">Kaydet</button>
            </div>
          </div>
        </div>
      )}

      {/* DETAY MODALI — tıklanan değere özel */}
      {detail && (
        <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/60 p-4 overflow-y-auto" onMouseDown={() => setDetail(null)}>
          <div className={`bg-white rounded-lg shadow-2xl w-full my-8 ${detail.kind === "makine" ? "max-w-[96vw]" : "max-w-5xl"}`} onMouseDown={(e) => e.stopPropagation()} data-testid="detail-modal">
            <div className="flex items-center justify-between border-b border-zinc-200 px-5 py-3 bg-zinc-900 rounded-t-lg">
              <h3 className="font-head font-black text-white uppercase tracking-widest text-sm" data-testid="detail-title">{detail.label}</h3>
              <button onClick={() => setDetail(null)} data-testid="detail-close" className="text-zinc-400 hover:text-white"><X size={18} /></button>
            </div>
            <div className="p-5 max-h-[85vh] overflow-auto">
              {detail.kind === "kalite" && (() => {
                const field = detail.field;
                const rows = (kalDetay || []).filter((r) => (Number(r[field]) || 0) > 0).sort((a, b) => (Number(b[field]) || 0) - (Number(a[field]) || 0));
                const isKg = field === "kg";
                const toplam = rows.reduce((a, b) => a + (Number(b[field]) || 0), 0);
                const kLabel = isKg ? "KG" : detail.label;
                const kEsc2 = (v) => String(v ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
                const detExcel = () => {
                  const cap = kFiltreMetni ? `<tr><td colspan="3" style="background:#FEF3C7;font-weight:bold;">Filtre: ${kEsc2(kFiltreMetni)}</td></tr>` : "";
                  const head = ["Ürün Kodu", "Açıklama", kLabel].map((c) => `<th style="background:#18181B;color:#fff;font-weight:bold;">${kEsc2(c)}</th>`).join("");
                  const body = rows.map((r) => `<tr><td>${kEsc2(r.urun_kodu)}</td><td>${kEsc2(r.aciklama)}</td><td>${isKg ? r.kg : r[field]}</td></tr>`).join("");
                  const foot = `<tr style="background:#E9E9E9;font-weight:bold;"><td>TOPLAM</td><td></td><td>${Math.round(toplam)}</td></tr>`;
                  const html = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel"><head><meta charset="utf-8"></head><body><table border="1">${cap}<tr>${head}</tr>${body}${foot}</table></body></html>`;
                  const blob = new Blob(["\ufeff", html], { type: "application/vnd.ms-excel" });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement("a"); a.href = url; a.download = `${detail.label} - ${damga()}.xls`; a.click();
                  URL.revokeObjectURL(url);
                };
                const detPdf = () => {
                  const w = window.open("", "_blank"); if (!w) return;
                  const body = rows.map((r) => `<tr><td class="mono">${kEsc2(r.urun_kodu)}</td><td>${kEsc2(r.aciklama)}</td><td class="r" style="font-weight:bold">${(isKg ? r.kg : r[field]).toLocaleString("tr-TR")}</td></tr>`).join("");
                  w.document.write(`<!DOCTYPE html><html lang="tr"><head><meta charset="utf-8"><title>${kEsc2(detail.label)} - ${damga()}</title>
                    <style>@page{size:A4 portrait;margin:12mm}*{-webkit-print-color-adjust:exact;print-color-adjust:exact}body{font-family:'Segoe UI',Arial,sans-serif;color:#18181B;margin:0}
                    .hdr{display:flex;align-items:center;justify-content:space-between;border-bottom:3px solid #d97706;padding-bottom:12px;margin-bottom:10px}.hdr .l{display:flex;align-items:center;gap:14px}.hdr img{height:52px}.hdr h1{font-size:19px;margin:0}.hdr .sub{font-size:12px;color:#6b7280;margin-top:2px}.hdr .meta{text-align:right;font-size:11px;color:#6b7280;line-height:1.6}
                    .card{border:1px solid #e5e7eb;border-radius:8px;padding:10px 14px;background:#fafafa;margin-bottom:12px;display:inline-block}.card .k{font-size:10px;text-transform:uppercase;letter-spacing:1.5px;color:#9ca3af}.card .v{font-size:22px;font-weight:800;margin-top:4px}
                    table{width:100%;border-collapse:collapse;font-size:11px}th{background:#18181B;color:#fff;padding:8px;text-align:left;font-size:10px;text-transform:uppercase}td{border-bottom:1px solid #eee;padding:6px 8px}.r{text-align:right}.mono{font-family:'Courier New',monospace}
                    tfoot td{border-top:2px solid #18181B;font-weight:800;background:#f4f4f5}.foot{margin-top:16px;font-size:10px;color:#9ca3af;text-align:center;border-top:1px solid #eee;padding-top:8px}</style></head>
                    <body><div class="hdr"><div class="l"><img src="${window.location.origin}/by-bone-logo.png"/><div><h1>${kEsc2(detail.label)} — Ürün Bazında</h1><div class="sub">BY BONE PORSELEN — Kalite Detay Raporu</div></div></div>
                    <div class="meta">Tarih: ${new Date().toLocaleString("tr-TR")}<br/>Ürün çeşidi: ${rows.length}${kFiltreMetni ? `<br/>Filtre: ${kEsc2(kFiltreMetni)}` : ""}</div></div>
                    <div class="card"><div class="k">${kEsc2(kLabel)} Toplam</div><div class="v" style="color:#b45309">${Math.round(toplam).toLocaleString("tr-TR")}</div></div>
                    <table><thead><tr><th>Ürün Kodu</th><th>Açıklama</th><th class="r">${kEsc2(kLabel)}</th></tr></thead>
                    <tbody>${body}</tbody><tfoot><tr><td>TOPLAM</td><td></td><td class="r">${Math.round(toplam).toLocaleString("tr-TR")}</td></tr></tfoot></table>
                    <div class="foot">Bu rapor BY BONE Üretim Takip Sistemi tarafından otomatik oluşturulmuştur.</div></body></html>`);
                  w.document.close(); w.focus(); setTimeout(() => w.print(), 400);
                };
                return (
                  <>
                    {!kalDetay ? <div className="py-10 text-center text-zinc-400"><Loader2 className="animate-spin inline" size={18} /> Yükleniyor...</div> : (
                      <>
                        <div className="flex items-center justify-between mb-2">
                          <div className="text-xs text-zinc-500">{rows.length} ürün · yalnızca <b>{detail.label}</b> verisi (büyükten küçüğe)</div>
                          <div className="flex items-center gap-2">
                            <button onClick={detExcel} data-testid="kalite-detay-excel-btn" className="flex items-center gap-1.5 bg-green-700 hover:bg-green-800 text-white text-xs font-semibold px-2.5 py-1.5 rounded-sm"><FileDown size={14} /> Excel'e Aktar</button>
                            <button onClick={detPdf} data-testid="kalite-detay-pdf-btn" className="flex items-center gap-1.5 bg-zinc-800 hover:bg-zinc-900 text-white text-xs font-semibold px-2.5 py-1.5 rounded-sm"><Printer size={14} /> PDF İndir</button>
                          </div>
                        </div>
                        <table className="w-full text-sm border border-zinc-200 rounded">
                          <thead className="bg-zinc-50"><tr><Th>Ürün Kodu</Th><Th>Açıklama</Th><Th r>{isKg ? "KG" : detail.label}</Th></tr></thead>
                          <tbody>
                            {rows.slice(0, 400).map((r, i) => (
                              <tr key={i}><Td cls="mono">{r.urun_kodu}</Td><Td cls="max-w-[380px] truncate">{r.aciklama || "—"}</Td><Td r cls="font-semibold">{isKg ? `${fmt(r.kg)}` : fmt(r[field])}</Td></tr>
                            ))}
                            <tr className="bg-zinc-100 font-bold"><Td>TOPLAM</Td><Td /><Td r>{isKg ? fmt(Math.round(toplam)) : fmt(toplam)}</Td></tr>
                            {rows.length === 0 && <tr><Td>Kayıt yok.</Td><Td /><Td /></tr>}
                          </tbody>
                        </table>
                        {(() => {
                          const hr = hataRows();
                          if (!hr.length) return null;
                          return (
                            <div className="mt-5" data-testid="hata-neden-dokumu">
                              <div className="text-xs font-bold uppercase tracking-wide text-zinc-500 mb-2">
                                Hata Nedeni Dökümü — 2. Kalite &amp; Fire Nedenleri{kFiltreMetni ? ` · ${kFiltreMetni}` : ""}
                              </div>
                              <table className="w-full text-sm border border-zinc-200 rounded">
                                <thead className="bg-zinc-50"><tr><Th>Hata Nedeni</Th><Th r>Adet</Th><Th r>Pay</Th></tr></thead>
                                <tbody>
                                  {hr.map((e, i) => (
                                    <tr key={i}><Td cls="font-medium">{e.ad}</Td><Td r cls="font-semibold text-red-600">{fmt(e.adet)}</Td><Td r cls="text-zinc-500">%{hPctNum(e.adet)}</Td></tr>
                                  ))}
                                  <tr className="bg-zinc-100 font-bold"><Td>TOPLAM</Td><Td r>{fmt(Math.round(hataToplam))}</Td><Td r>%100</Td></tr>
                                </tbody>
                              </table>
                            </div>
                          );
                        })()}
                      </>
                    )}
                  </>
                );
              })()}

              {detail.kind === "siparis" && (() => {
                const rows = filterSiparis(siparisDetay, detail.filter).sort((a, b) => (Number(b.kalan) || 0) - (Number(a.kalan) || 0));
                return (
                  <>
                    {!siparisDetay ? <div className="py-10 text-center text-zinc-400"><Loader2 className="animate-spin inline" size={18} /> Yükleniyor...</div> : (
                      <>
                        <div className="text-xs text-zinc-500 mb-2">{rows.length} kalem · kalan adete göre sıralı</div>
                        <table className="w-full text-sm border border-zinc-200 rounded">
                          <thead className="bg-zinc-50"><tr><Th>Müşteri</Th><Th>Ürün Kodu</Th><Th>Satış Noktası</Th><Th>Satış Müşterisi</Th><Th r>Sipariş</Th><Th r>Kalan</Th></tr></thead>
                          <tbody>
                            {rows.slice(0, 300).map((o, i) => (
                              <tr key={o.id || i}>
                                <Td cls="max-w-[220px] truncate">{o.musteri || "—"}</Td>
                                <Td cls="mono">{o.urun_kodu}</Td>
                                <Td>{o.satis_noktasi || "—"}</Td>
                                <Td>{(o.satis_noktasi || "").toLowerCase().includes("horeca") ? (o.satis_musterisi || "—") : "—"}</Td>
                                <Td r>{fmt(o.siparis_adeti)}</Td>
                                <Td r cls="text-red-600 font-bold">{fmt(o.kalan)}</Td>
                              </tr>
                            ))}
                            {rows.length === 0 && <tr><Td>Kayıt yok.</Td><Td /><Td /><Td /><Td /><Td /></tr>}
                          </tbody>
                        </table>
                      </>
                    )}
                  </>
                );
              })()}

              {detail.kind === "yapilan" && (() => {
                const d = yapilanDetay;
                return (
                  <>
                    {!d ? <div className="py-10 text-center text-zinc-400"><Loader2 className="animate-spin inline" size={18} /> Yükleniyor...</div> : (
                      <>
                        <div className="text-xs text-zinc-500 mb-2">{d.rows.length} kayıt · Üretim: <b>{fmt(d.toplam_adet)}</b> · Fire: <b className="text-red-600">{fmt(d.toplam_fire)}</b> · KG: <b className="text-amber-700">{fmt(d.toplam_kg)}</b></div>
                        <table className="w-full text-sm border border-zinc-200 rounded">
                          <thead className="bg-zinc-50"><tr><Th>Tarih</Th><Th>Vardiya</Th><Th>Bölüm</Th><Th>Ürün Kodu</Th><Th>Renk</Th><Th r>1.Kalite</Th><Th r>Fire</Th><Th r>Toplam</Th><Th r>KG</Th></tr></thead>
                          <tbody>
                            {d.rows.slice(0, 400).map((r, i) => (
                              <tr key={i}>
                                <Td cls="num">{trTarih(r.tarih)}</Td>
                                <Td>{r.vardiya}</Td>
                                <Td>{r.bolum}</Td>
                                <Td cls="mono">{r.urun_kodu}</Td>
                                <Td>{r.renk || "—"}</Td>
                                <Td r cls="text-emerald-700 font-semibold">{fmt(r.kalite1)}</Td>
                                <Td r cls="text-red-600">{fmt(r.fire)}</Td>
                                <Td r cls="font-semibold">{fmt(r.toplam)}</Td>
                                <Td r cls="text-amber-700 font-semibold">{fmt(r.kg)}</Td>
                              </tr>
                            ))}
                            {d.rows.length === 0 && <tr><Td>Kayıt yok.</Td><Td /><Td /><Td /><Td /><Td /><Td /><Td /><Td /></tr>}
                          </tbody>
                        </table>
                      </>
                    )}
                  </>
                );
              })()}

              {detail.kind === "plan" && (() => {
                const rows = (planDetay || []).filter((p) => {
                  if (detail.durum !== "all" && p.durum !== detail.durum) return false;
                  const t = (p.tarih || "").slice(0, 10);
                  if (detail.tarih) return t === detail.tarih;
                  if (planStart && t && t < planStart) return false;
                  if (planEnd && t && t > planEnd) return false;
                  return true;
                });
                const aralik = detail.tarih ? trTarih(detail.tarih) : ((planStart || planEnd) ? `${planStart ? trTarih(planStart) : "…"} – ${planEnd ? trTarih(planEnd) : "…"}` : "tüm tarihler");
                return (
                  <>
                    {!planDetay ? <div className="py-10 text-center text-zinc-400"><Loader2 className="animate-spin inline" size={18} /> Yükleniyor...</div> : (
                      <>
                        <div className="text-xs text-zinc-500 mb-2">{rows.length} plan kalemi · <b>{aralik}</b></div>
                        <table className="w-full text-sm border border-zinc-200 rounded">
                          <thead className="bg-zinc-50"><tr><Th>Tarih</Th><Th>Ürün</Th><Th>Bölüm</Th><Th r>Planlanan</Th><Th r>Yapılan</Th><Th r>Eksik</Th><Th>Durum</Th></tr></thead>
                          <tbody>
                            {rows.slice(0, 400).map((p, i) => {
                              const dcls = p.durum === "Yapıldı" ? "bg-emerald-100 text-emerald-700" : p.durum === "Kısmi" ? "bg-amber-100 text-amber-700" : "bg-red-100 text-red-700";
                              return (
                                <tr key={i}>
                                  <Td cls="mono whitespace-nowrap">{trTarih(p.tarih)}</Td>
                                  <Td cls="mono">{p.urun_kodu}</Td>
                                  <Td>{p.bolum || "—"}</Td>
                                  <Td r>{fmt(p.planlanan)}</Td>
                                  <Td r cls="text-emerald-700 font-semibold">{fmt(p.yapilan)}</Td>
                                  <Td r cls="text-red-600">{fmt(p.eksik)}</Td>
                                  <Td><span className={`px-2 py-0.5 rounded text-xs font-semibold ${dcls}`}>{p.durum}</span></Td>
                                </tr>
                              );
                            })}
                            {rows.length === 0 && <tr><Td>Kayıt yok.</Td><Td /><Td /><Td /><Td /><Td /><Td /></tr>}
                          </tbody>
                        </table>
                      </>
                    )}
                  </>
                );
              })()}

              {detail.kind === "termin" && (() => {
                const rows = [...termin].filter((t) => detail.durum === "all" ? true : t.termin_durum === detail.durum)
                  .sort((a, b) => (a.kalan_gun ?? 1e9) - (b.kalan_gun ?? 1e9));
                return (
                  <>
                    <div className="text-xs text-zinc-500 mb-2">{rows.length} sipariş</div>
                    <table className="w-full text-sm border border-zinc-200 rounded">
                      <thead className="bg-zinc-50"><tr><Th>Termin</Th><Th>Durum</Th><Th>Müşteri</Th><Th>Ürün Kodu</Th><Th r>Sipariş</Th><Th r>Kalan</Th><Th r>Kaliteden Geçmeyen Ürünler</Th><Th>Süre</Th></tr></thead>
                      <tbody>
                        {rows.slice(0, 400).map((t, i) => {
                          const cfg = TCFG[t.termin_durum] || {};
                          const b = t.termin_durum === "gecti" ? "bg-red-100 text-red-700" : t.termin_durum === "yaklasiyor" ? "bg-emerald-100 text-emerald-700" : "bg-sky-100 text-sky-700";
                          return (
                            <tr key={t.id || i}>
                              <Td cls="mono whitespace-nowrap">{trTarih(t.termin_tarihi)}</Td>
                              <Td><span className={`px-2 py-0.5 rounded text-xs font-semibold ${b}`}>{cfg.label || "—"}</span></Td>
                              <Td cls="max-w-[200px] truncate">{t.musteri || "—"}</Td>
                              <Td cls="mono">{t.urun_kodu}</Td>
                              <Td r>{fmt(t.siparis_adeti)}</Td>
                              <Td r cls="font-semibold">{fmt(t.kalan)}</Td>
                              <Td r><KaliteGecmeyenCell row={t} /></Td>
                              <Td cls="text-xs font-semibold whitespace-nowrap">{gunLabel(t.kalan_gun)}</Td>
                            </tr>
                          );
                        })}
                        {rows.length === 0 && <tr><Td>Kayıt yok.</Td><Td /><Td /><Td /><Td /><Td /><Td /><Td /></tr>}
                      </tbody>
                    </table>
                  </>
                );
              })()}

              {detail.kind === "makine" && (() => {
                const rows = (makineDetay || []).filter((r) => !detail.makina || r.makina === detail.makina);
                const esc = (v) => String(v ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
                const totals = {
                  sekillenen: rows.reduce((a, b) => a + b.sekillenen, 0),
                  defo: rows.reduce((a, b) => a + b.defo, 0),
                  net: rows.reduce((a, b) => a + b.net, 0),
                  brut: rows.reduce((a, b) => a + (b.brut || 0), 0),
                  net_kg: rows.reduce((a, b) => a + (b.net_kg || 0), 0),
                  defo_kg: rows.reduce((a, b) => a + (b.defo_kg || 0), 0),
                  brut_kg: rows.reduce((a, b) => a + (b.brut_kg || 0), 0),
                  hedef: rows.reduce((a, b) => a + (b.hedef || 0), 0),
                };
                const totalPct = totals.hedef ? Math.round(totals.net / totals.hedef * 1000) / 10 : 0;
                const baslik = `Makine Üretim Raporu — ${detail.makina || "Tüm Makineler"}`;
                const exportExcel = () => {
                  const cols = ["Makine", "Makina İsmi", "Ürün", "Şekillenen", "Defo", "Net (Slim)", "Brüt Şekillenen", "Net KG", "Defo KG", "Brüt KG", "Defo Oranı", "Kapasite Oranı"];
                  const head = cols.map((c) => `<th style="background:#18181B;color:#fff;font-weight:bold;">${esc(c)}</th>`).join("");
                  const body = rows.map((r) => `<tr><td>${esc(r.makina)}</td><td>${esc(r.plan_makina)}</td><td>${esc(r.urun_kodu)}</td><td>${r.sekillenen}</td><td>${r.defo}</td><td>${r.net}</td><td>${r.brut}</td><td>${r.net_kg}</td><td>${r.defo_kg}</td><td>${r.brut_kg}</td><td>%${r.defo_orani}</td><td>${r.kapasite ? "%" + r.kapasite_orani : "-"}</td></tr>`).join("");
                  const foot = `<tr style="background:#E9E9E9;font-weight:bold;"><td>TOPLAM</td><td></td><td></td><td>${totals.sekillenen}</td><td>${totals.defo}</td><td>${totals.net}</td><td>${totals.brut}</td><td>${Math.round(totals.net_kg * 10) / 10}</td><td>${Math.round(totals.defo_kg * 10) / 10}</td><td>${Math.round(totals.brut_kg * 10) / 10}</td><td></td><td>${totals.hedef ? "%" + totalPct : "-"}</td></tr>`;
                  const html = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel"><head><meta charset="utf-8"></head><body><table border="1"><tr>${head}</tr>${body}${foot}</table></body></html>`;
                  const blob = new Blob(["\ufeff", html], { type: "application/vnd.ms-excel" });
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement("a"); a.href = url; a.download = `${baslik} - ${damga()}.xls`; a.click();
                  URL.revokeObjectURL(url);
                };
                const pctColor = (p) => (p >= 100 ? "#047857" : p >= 70 ? "#b45309" : "#dc2626");
                const exportPdf = () => {
                  const w = window.open("", "_blank"); if (!w) return;
                  const body = rows.map((r, idx) => {
                    const yeni = idx === 0 || rows[idx - 1].makina !== r.makina;
                    return `<tr${yeni ? ' style="border-top:2px solid #18181B"' : ""}>
                      <td class="m">${yeni ? esc(r.makina) : ""}</td><td style="color:#4338ca;font-weight:600">${esc(r.plan_makina)}</td><td class="mono" style="white-space:nowrap">${esc(r.urun_kodu)}</td>
                      <td class="r">${r.sekillenen.toLocaleString("tr-TR")}</td><td class="r" style="color:#dc2626">${r.defo.toLocaleString("tr-TR")}</td>
                      <td class="r" style="color:#047857;font-weight:bold">${r.net.toLocaleString("tr-TR")}</td><td class="r" style="color:#0369a1">${r.brut.toLocaleString("tr-TR")}</td><td class="r" style="color:#b45309">${r.net_kg.toLocaleString("tr-TR")}</td><td class="r" style="color:#b45309">${r.defo_kg.toLocaleString("tr-TR")}</td><td class="r" style="color:#b45309">${r.brut_kg.toLocaleString("tr-TR")}</td>
                      <td class="r">%${r.defo_orani}</td>
                      <td class="r" style="font-weight:bold;color:${r.kapasite ? pctColor(r.kapasite_orani) : "#9ca3af"}">${r.kapasite ? "%" + r.kapasite_orani : "—"}</td></tr>`;
                  }).join("");
                  w.document.write(`<!DOCTYPE html><html lang="tr"><head><meta charset="utf-8"><title>${esc(baslik)} - ${damga()}</title>
                    <style>@page{size:A4 landscape;margin:12mm}*{-webkit-print-color-adjust:exact;print-color-adjust:exact}body{font-family:'Segoe UI',Arial,sans-serif;color:#18181B;margin:0}
                    .hdr{display:flex;align-items:center;justify-content:space-between;border-bottom:3px solid #d97706;padding-bottom:12px;margin-bottom:6px}
                    .hdr .l{display:flex;align-items:center;gap:14px}.hdr img{height:52px}.hdr h1{font-size:20px;margin:0;letter-spacing:.5px}.hdr .sub{font-size:12px;color:#6b7280;margin-top:2px}
                    .hdr .meta{text-align:right;font-size:11px;color:#6b7280;line-height:1.6}
                    .cards{display:flex;gap:12px;margin:14px 0}
                    .card{flex:1;border:1px solid #e5e7eb;border-radius:8px;padding:10px 14px;background:#fafafa}
                    .card .k{font-size:10px;text-transform:uppercase;letter-spacing:1.5px;color:#9ca3af}.card .v{font-size:22px;font-weight:800;margin-top:4px}
                    table{width:100%;border-collapse:collapse;font-size:11px;margin-top:6px}
                    th{background:#18181B;color:#fff;padding:8px 8px;text-align:left;font-size:10px;text-transform:uppercase;letter-spacing:.5px}
                    td{border-bottom:1px solid #eee;padding:6px 8px}.r{text-align:right}.m{font-weight:bold}.mono{font-family:'Courier New',monospace}
                    tfoot td{border-top:2px solid #18181B;font-weight:800;background:#f4f4f5}
                    .foot{margin-top:16px;font-size:10px;color:#9ca3af;text-align:center;border-top:1px solid #eee;padding-top:8px}</style></head>
                    <body>
                    <div class="hdr"><div class="l"><img src="${window.location.origin}/by-bone-logo.png"/><div><h1>${esc(baslik)}</h1><div class="sub">BY BONE PORSELEN — Şekillendirme Üretim Performans Raporu</div></div></div>
                    <div class="meta">Tarih: ${new Date().toLocaleString("tr-TR")}<br/>Ürün çeşidi: ${rows.length}<br/>Hazırlayan: Üretim Takip Sistemi</div></div>
                    <div class="cards">
                      <div class="card"><div class="k">Toplam Şekillenen</div><div class="v">${totals.sekillenen.toLocaleString("tr-TR")}</div></div>
                      <div class="card"><div class="k">Net (Silim)</div><div class="v" style="color:#047857">${totals.net.toLocaleString("tr-TR")}</div></div>
                      <div class="card"><div class="k">Hedef (Kapasite)</div><div class="v" style="color:#0369a1">${totals.hedef.toLocaleString("tr-TR")}</div></div>
                      <div class="card"><div class="k">Kapasite Gerçekleşme</div><div class="v" style="color:${totals.hedef ? pctColor(totalPct) : "#9ca3af"}">${totals.hedef ? "%" + totalPct : "—"}</div></div>
                    </div>
                    <table><thead><tr><th>Makine</th><th>Makina İsmi</th><th>Ürün</th><th class="r">Şekillenen</th><th class="r">Defo</th><th class="r">Net (Slim)</th><th class="r">Brüt Şekillenen</th><th class="r">Net KG</th><th class="r">Defo KG</th><th class="r">Brüt KG</th><th class="r">Defo Oranı</th><th class="r">Kapasite Oranı</th></tr></thead>
                    <tbody>${body}</tbody>
                    <tfoot><tr><td>TOPLAM</td><td></td><td></td><td class="r">${totals.sekillenen.toLocaleString("tr-TR")}</td><td class="r">${totals.defo.toLocaleString("tr-TR")}</td><td class="r">${totals.net.toLocaleString("tr-TR")}</td><td class="r">${totals.brut.toLocaleString("tr-TR")}</td><td class="r">${(Math.round(totals.net_kg * 10) / 10).toLocaleString("tr-TR")}</td><td class="r">${(Math.round(totals.defo_kg * 10) / 10).toLocaleString("tr-TR")}</td><td class="r">${(Math.round(totals.brut_kg * 10) / 10).toLocaleString("tr-TR")}</td><td></td><td class="r" style="color:${totals.hedef ? pctColor(totalPct) : "#9ca3af"}">${totals.hedef ? "%" + totalPct : "—"}</td></tr></tfoot></table>
                    <div class="foot">Bu rapor BY BONE Üretim Takip Sistemi tarafından otomatik oluşturulmuştur.</div>
                    </body></html>`);
                  w.document.close(); w.focus(); setTimeout(() => w.print(), 400);
                };
                return (
                  <>
                    {!makineDetay ? <div className="py-10 text-center text-zinc-400"><Loader2 className="animate-spin inline" size={18} /> Yükleniyor...</div> : (
                      <>
                        <div className="flex items-center justify-between mb-2">
                          <div className="text-xs text-zinc-500">{rows.length} ürün · {detail.makina || "tüm makineler"}</div>
                          <div className="flex items-center gap-2">
                            <button onClick={exportExcel} data-testid="makine-excel-btn" className="flex items-center gap-1.5 bg-green-700 hover:bg-green-800 text-white text-xs font-semibold px-2.5 py-1.5 rounded-sm"><FileDown size={14} /> Excel'e Aktar</button>
                            <button onClick={exportPdf} data-testid="makine-pdf-btn" className="flex items-center gap-1.5 bg-zinc-800 hover:bg-zinc-900 text-white text-xs font-semibold px-2.5 py-1.5 rounded-sm"><Printer size={14} /> PDF İndir</button>
                          </div>
                        </div>
                        <div className="rounded-lg border border-zinc-200 shadow-sm">
                        <table className="w-full text-xs [&_th]:px-1.5 [&_th]:py-1.5 [&_th]:text-[9px] [&_td]:px-1.5 [&_td]:py-1.5">
                          <thead><tr><Th>Makine</Th><Th>Makina İsmi</Th><Th>Ürün</Th><Th r>Şekillenen</Th><Th r>Defo</Th><Th r>Net (Slim)</Th><Th r>Brüt Şekillenen</Th><Th r>Net KG</Th><Th r>Defo KG</Th><Th r>Brüt KG</Th><Th r>Defo Oranı</Th><Th r>Kapasite Oranı</Th></tr></thead>
                          <tbody>
                            {rows.map((r, i) => {
                              const yeni = i === 0 || rows[i - 1].makina !== r.makina;
                              const dp = Number(r.defo_orani) || 0;
                              const dCls = dp >= 10 ? "bg-red-100 text-red-700" : dp >= 5 ? "bg-amber-100 text-amber-700" : "bg-emerald-100 text-emerald-700";
                              const kp = Number(r.kapasite_orani) || 0;
                              const kCls = kp >= 100 ? "bg-emerald-100 text-emerald-700" : kp >= 70 ? "bg-amber-100 text-amber-700" : "bg-red-100 text-red-700";
                              return (
                                <tr key={i} className={`${yeni ? "border-t-2 border-zinc-200 " : ""}${i % 2 ? "bg-zinc-50/70 " : "bg-white "}hover:bg-amber-50/60 transition-colors`}>
                                  <Td cls={`whitespace-nowrap ${yeni ? "font-bold text-zinc-800" : "text-zinc-300"}`}>{yeni ? r.makina : ""}</Td>
                                  <Td cls="text-indigo-700 font-medium whitespace-nowrap">{r.plan_makina || "—"}</Td>
                                  <Td cls="mono font-semibold text-zinc-800 whitespace-nowrap">{r.urun_kodu}</Td>
                                  <Td r cls="whitespace-nowrap">{fmt(r.sekillenen)}</Td>
                                  <Td r cls="text-red-600 whitespace-nowrap">{fmt(r.defo)}</Td>
                                  <Td r cls="text-emerald-700 font-bold whitespace-nowrap">{fmt(r.net)}</Td>
                                  <Td r cls="text-sky-700 whitespace-nowrap">{fmt(r.brut)}</Td>
                                  <Td r cls="text-amber-600 whitespace-nowrap">{fmt(r.net_kg)}</Td>
                                  <Td r cls="text-amber-600 whitespace-nowrap">{fmt(r.defo_kg)}</Td>
                                  <Td r cls="text-amber-600 whitespace-nowrap">{fmt(r.brut_kg)}</Td>
                                  <Td r cls="whitespace-nowrap"><span className={`inline-block rounded-full px-2 py-0.5 text-xs font-bold ${dCls}`}>%{r.defo_orani}</span></Td>
                                  <Td r cls="whitespace-nowrap">{r.kapasite ? <span className={`inline-block rounded-full px-2 py-0.5 text-xs font-bold ${kCls}`}>%{r.kapasite_orani}</span> : <span className="text-zinc-400 text-xs">—</span>}</Td>
                                </tr>
                              );
                            })}
                            {rows.length > 0 && (
                              <tr className="bg-zinc-900 font-bold">
                                <Td cls="text-white whitespace-nowrap">TOPLAM</Td><Td /><Td />
                                <Td r cls="text-white">{fmt(rows.reduce((a, b) => a + b.sekillenen, 0))}</Td>
                                <Td r cls="text-red-300">{fmt(rows.reduce((a, b) => a + b.defo, 0))}</Td>
                                <Td r cls="text-emerald-300">{fmt(rows.reduce((a, b) => a + b.net, 0))}</Td>
                                <Td r cls="text-sky-300">{fmt(rows.reduce((a, b) => a + (b.brut || 0), 0))}</Td>
                                <Td r cls="text-amber-300">{fmt(Math.round(rows.reduce((a, b) => a + (b.net_kg || 0), 0) * 10) / 10)}</Td>
                                <Td r cls="text-amber-300">{fmt(Math.round(rows.reduce((a, b) => a + (b.defo_kg || 0), 0) * 10) / 10)}</Td>
                                <Td r cls="text-amber-300">{fmt(Math.round(rows.reduce((a, b) => a + (b.brut_kg || 0), 0) * 10) / 10)}</Td>
                                <Td />
                                <Td r cls="text-white">{(() => {
                                  const th = rows.reduce((a, b) => a + (b.hedef || 0), 0);
                                  const tn = rows.reduce((a, b) => a + b.net, 0);
                                  return th ? `%${Math.round(tn / th * 1000) / 10}` : "—";
                                })()}</Td>
                              </tr>
                            )}
                            {rows.length === 0 && <tr><Td>Kayıt yok.</Td><Td /><Td /><Td /><Td /><Td /><Td /><Td /><Td /><Td /><Td /><Td /></tr>}
                          </tbody>
                        </table>
                        </div>
                      </>
                    )}
                  </>
                );
              })()}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
